import style from './Clima.module.css'
import './Clima.css'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { TemaContext } from '../../common/context/TemaContext';
import { LinguagemContext } from '../../common/context/LinguagemContext';
import { UsuarioContext } from '../../common/context/UsuarioContext';
import { useNavigate} from 'react-router-dom';
import { useTranslation} from 'react-i18next';
import Translator from '../I18n/Translator';
import L from 'leaflet';
import { Box, Slider, TextField, Autocomplete, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, Typography} from '@mui/material';
import Moment from 'react-moment';
import 'chartjs-adapter-moment';
import {Line } from 'react-chartjs-2';
import PopupGrafico from '../PopupGrafico';
import Footer from '../Footer';
import moment from 'moment';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import chroma from 'chroma-js';
import iconAmareloUrl from './icone_alerta_amarelo.png'; // Importe o ícone de imagem 1
import iconVermelhoUrl from './icone_alerta_vermelho.png'; // Importe o ícone de imagem 3
import TabNav from '../TabNav';
import CookieService from '../../service/CookieService';
import { ServerContext } from '../../common/context/ServerContext';
import { feature } from 'topojson-client'; // <- importando a função de conversão


var teste_data = "";

var cod_estados = [
    {"UF":"AC",
    "COD": 12, "NOME":"Acre"},
    {"UF":"AL",
    "COD": 27, "NOME":"Alagoas"},
    {"UF":"AP",
    "COD": 16, "NOME":"Amapá"},
    {"UF":"AM",
    "COD": 13, "NOME":"Amazonas"},
    {"UF":"BA",
    "COD": 29, "NOME":"Bahia"},
    {"UF":"CE",
    "COD": 23, "NOME":"Ceará"},
    {"UF":"DF",
    "COD": 53, "NOME":"Distrito Federal"},
    {"UF":"ES",
    "COD": 32, "NOME":"Espírito Santo"},
    {"UF":"GO",
    "COD": 52, "NOME":"Goiás"},
    {"UF":"MA",
    "COD": 21, "NOME":"Maranhão"},
    {"UF":"MT",
    "COD": 51, "NOME":"Mato Grosso"},
    {"UF":"MS",
    "COD": 50, "NOME":"Mato Grosso do Sul"},
    {"UF":"MG",
    "COD": 31, "NOME":"Minas Gerais"},
    {"UF":"PA",
    "COD": 15, "NOME":"Pará"},
    {"UF":"PB",
    "COD": 25, "NOME":"Paraíba"},
    {"UF":"PR",
    "COD": 41, "NOME":"Paraná"},
    {"UF":"PE",
    "COD": 26, "NOME":"Pernambuco"},
    {"UF":"PI",
    "COD": 22, "NOME":"Piauí"},
    {"UF":"RJ",
    "COD": 33, "NOME":"Rio de Janeiro"},
    {"UF":"RN",
    "COD": 24, "NOME":"Rio Grande do Norte"},
    {"UF":"RS",
    "COD": 43, "NOME":"Rio Grande do Sul"},
    {"UF":"RO",
    "COD": 11,"NOME":"Rondônia"},
    {"UF":"RR",
    "COD": 14,"NOME":"Roraima"},
    {"UF":"SC",
    "COD": 42,"NOME":"Santa Catarina"},        
    {"UF":"SP",
    "COD": 35,"NOME":"São Paulo"},
    {"UF":"SE",
    "COD": 28,"NOME":"Sergipe"},
    {"UF":"TO",
    "COD": 17,"NOME":"Tocantins"},
];

var posicao = localStorage.getItem('posicaoScroll');

var _logado = "";

const Clima1 = () => {
    const {theme} = useContext(TemaContext);
    const {language} = useContext(LinguagemContext);
    const {logado, setLogado} = useContext(UsuarioContext);
    const {servidor} = useContext(ServerContext);

    const corMapaNaoApto = useMemo(() => {  
        return "#9E9E9E"; 
    }, []); 

    const corMapaNaoAptoDark = useMemo(() => {  
        return "#757575"; 
    }, []); 

    const corMapaNoData = useMemo(() => {  
        return "#efefef"; 
    }, []); 

    const { t } = useTranslation();
    const navigate = useNavigate();

    const position = [-15.0, -54.27390005057997];
    const defaultZoom = 3.00;
    const zoomSnap_ = 0.25;
    const wheelPxPerZoomLevel_ = 120;

    var alterandoData = false;

    let dataDados = localStorage.getItem('dataCacheFiles');

    var weightNormal = theme === "dark" ? 0.5 : 0.3;
    var weightBrasil = 1.5;

    var weightSelecao = 2.5; 

    const transparencia = useRef(0.5);

    var opacidadeMunicipio = 1.0;

    const transparenciaDefaultMapa = useMemo(() => {
        return "rgba(255, 255, 255, 0)";
    }, []);
    const cinzaDefaultMapaDark = useMemo(() => {
        return "#272727";
    }, []);
    const cinzaDefaultMapaBorda = useMemo(() => {
        return "#C1c3c3";//"rgba(221, 220, 223, 0.3)";
    }, []);

    const [indice, setIndice] = useState("ENS");

    const data_colormap = useRef([]);
    var color_scale = null;
    let escala = "ºC";

    let legenda = [];

    const handleChangeIndicador = (event) => {
        setIndice(event.target.value);
    };

    function checkDado(dado) {
        return dado['date'] === teste_data;
    }

    const [checkedAvisos, setCheckedAvisos] = useState(true);

    const getDadosGraficoTemp = (dados_temp, dados_temp_ivas, fullScreen) => {
        //let legenda_tmp = getLabelDataRange(minIdxDate, maxIdxDate);
        return {
            legenda,
            datasets: [
                {
                    label: t("dashboard.graficos.titulo_temp"),
                    data: dados_temp,
                    borderColor: "rgb(75, 192, 192)",
                    backgroundColor: "rgb(75, 192, 192)",
                    borderWidth: fullScreen ? 2 : 1,
                    pointBorderWidth: fullScreen ? 2 : 1.5,
                    pointRadius: fullScreen ? 1.5 : 1.3,
                    yAxisID: 'y',
                },
                {
                    label: t("dashboard.table.col7"),
                    data: dados_temp_ivas,
                    borderColor: "red"/*"rgb(75, 192, 192)"*/,
                    backgroundColor: "red",
                    borderWidth: fullScreen ? 2 : 1,
                    pointBorderWidth: fullScreen ? 2 : 1.5,
                    pointRadius: fullScreen ? 1.5 : 1.3,
                    yAxisID: 'y2',
                },
            ],

        };
    }


    const getDadosGraficoUm = (dados_Um, dados_temp_ivas, fullScreen) => {
        //let legenda_tmp = getLabelDataRange(minIdxDate, maxIdxDate);
        return {
            legenda,
            datasets: [
                {
                    label: t("dashboard.graficos.titulo_um"),
                    data: dados_Um,
                    borderColor: "rgb(196, 194, 255)",
                    backgroundColor: "rgb(196, 194, 255)",
                    borderWidth: fullScreen ? 2 : 1,
                    pointBorderWidth: fullScreen ? 2 : 1.5,
                    pointRadius: fullScreen ? 1.5 : 1.3,
                    yAxisID: 'y',
                },
                {
                    label: t("dashboard.table.col7"),
                    data: dados_temp_ivas,
                    borderColor: "red"/*"rgb(75, 192, 192)"*/,
                    backgroundColor: "red",
                    borderWidth: fullScreen ? 2 : 1,
                    pointBorderWidth: fullScreen ? 2 : 1.5,
                    pointRadius: fullScreen ? 1.5 : 1.3,
                    yAxisID: 'y2',
                },
            ],
        };
    }

    const getDadosGraficoPrec = (dados_prec, dados_temp_ivas, fullScreen) => {
        //let legenda_tmp = getLabelDataRange(minIdxDate, maxIdxDate);
        return {
            legenda,
            datasets: [
                {
                    label: t("dashboard.graficos.titulo_prec"),
                    data: dados_prec,
                    borderColor: "rgb(251, 104, 247)",
                    backgroundColor: "rgb(251, 104, 247)",
                    borderWidth: fullScreen ? 2 : 1,
                    pointBorderWidth: fullScreen ? 2 : 1.5,
                    pointRadius: fullScreen ? 1.5 : 1.3,
                    yAxisID: 'y',

                },
                {
                    label: t("dashboard.table.col7"),
                    data: dados_temp_ivas,
                    borderColor: "red"/*"rgb(75, 192, 192)"*/,
                    backgroundColor: "red",
                    borderWidth: fullScreen ? 2 : 1,
                    pointBorderWidth: fullScreen ? 2 : 1.5,
                    pointRadius: fullScreen ? 1.5 : 1.3,
                    yAxisID: 'y2',
                },
            ],

        };
    }

    const [dadosGraficoTemp, setDadosGraficoTemp] = useState(getDadosGraficoTemp([]));
    const [dadosGraficoUm, setDadosGraficoUm] = useState(getDadosGraficoUm([]));
    const [dadosGraficoPrec, setDadosGraficoPrec] = useState(getDadosGraficoPrec([]));
    const [dadosGraficoTempFull, setDadosGraficoTempFull] = useState(getDadosGraficoTemp([], true));
    const [dadosGraficoUmFull, setDadosGraficoUmFull] = useState(getDadosGraficoUm([], true));
    const [dadosGraficoPrecFull, setDadosGraficoPrecFull] = useState(getDadosGraficoPrec([], true));

        const carregandoEstado = useRef(false);
        const [carregouCache, setCarregouCache] = useState(false);
        const [filtrandoMunicipio, setFiltrandoMunicipio] = useState(false);

    const semanas_epidemiologicas = useRef(null);

    const [modal1Show, setModal1Show] = useState(false);
    const [modal2Show, setModal2Show] = useState(false);
    const [modal3Show, setModal3Show] = useState(false);

    const [markersLayer, setMarkersLayer] = useState(null);

    const [dados_municipios_por_data, setDados_Municipios_Por_Data] = useState(null);

    const dataInicial = useRef(new Date("2023-01-01"));

    let isResponsive = true;

    let maintainAspectRatio = false;

    let leftGrafico = 0;
    let rightGrafico = 0;
    let topGrafico = 0;
    let bottomGrafico = 0;

    const valorNil = "nil";

    var corLinhaMarcaoGrafico = (theme === "dark" ? "rgba(255, 255, 255, 1)" : "rgba(94, 94, 94, 1)");

    var texto_grafico_dark = "#fff";
    var texto_grafico_light = "#000";
    var fontGrafico = 10;

    const [valueRangeData, setValueRangeData] = useState([0,0]);

    const fixaCasasDecimais = (valor, casasDecimais) => {
        if(valor === valorNil) 
            return valorNil;
        return parseFloat(valor).toFixed(casasDecimais).replace(',', '.');
    }

    function exibeMesAnoGrafico(index, values){
        const totalTicks = values.length;

        const date = moment(values[index].value);
        
        // Sempre mostre o primeiro e o último tick
        if (index === 0 || index === totalTicks - 1) {
            return `${FormatarDoisDigitos(date.isoWeek())}-${date.year()}`;
        }
        // Lógica para mostrar ticks intermediários
        let intermediateTicks = 6; // número de ticks intermediários desejados

        let totalWeekTicks = Math.floor(totalTicks / 7);

        if(totalWeekTicks < intermediateTicks)
            intermediateTicks = totalWeekTicks - 2;
            if(intermediateTicks < 0)
                intermediateTicks = 0;

        const stepSize = Math.floor(totalTicks / (intermediateTicks + 1));

        if (index % stepSize === 0) {
            return `${FormatarDoisDigitos(date.isoWeek())}-${date.year()}`;
        }

        return null; // Não mostra outros ticks
    }

    //var geojsonBrasil = null;// (require('./Dados/shapefile/BR_UF_2022.json'));
    //var geojsonMunicipios = null;//(require('./Dados/shapefile/BR_Municipios_2022.json'));*/

    const [geojsonBrasil, setGeojsonBrasil] = useState(null);
    const [geojsonMunicipios, setGeojsonMunicipios] = useState(null);
    const [dadosCarregados, setDadosCarregados] = useState(false);

    async function fetchGeoJSON(url) {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Erro ao carregar ${url}: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Erro ao carregar o GeoJSON:", error);
            return null;
        }
    }
    
    async function loadGeoJSONData() {
        let brasilData = await fetchGeoJSON('Dados/topojson/BR_UF_2022.json');
        let municipiosData = await fetchGeoJSON('Dados/topojson/BR_Municipios_2022.json');

        brasilData = feature(brasilData, brasilData.objects.BR_UF_2022);
        municipiosData = feature(municipiosData, municipiosData.objects.BR_Municipios_2022);

        if (brasilData && municipiosData) {
            setGeojsonBrasil(brasilData);
            setGeojsonMunicipios(municipiosData);
            setDadosCarregados(true);
            //console.log("Dados carregados com sucesso:", {brasilData, municipiosData});
        } else {
            console.error("Falha ao carregar um ou mais arquivos GeoJSON.");
        }
    }

    

    const carregaCache = () => {
                if (filtrandoMunicipio || !iniciou.current){
                    //imprimeMensage(filtrandoMunicipio + " " + iniciou.current, "useEffect([[cod_ibge, dataSelecionada]]) 1 ");
        
                    return;
                
                }
        
                setFiltrandoMunicipio(true);
                //resetShapeFile();
        
                if(!carregouCache){
                    
                    let cod_ibge_tmp = localStorage.getItem('codibgeMunicipioSelecionadoDashboard');
                    let estadoSelecionadoTmpLocal = localStorage.getItem('estadoSelecionadoDashboard');
                    let municipioSelecionadoTmpLocal = localStorage.getItem('municipioSelecionadoDashboard');
        
        
                    //imprimeMensage(estadoSelecionadoTmp, municipioSelecionadoTmp, estadoSelecionadoTmpLocal, municipioSelecionadoTmpLocal);
        
                    if(isAllSelect(estadoSelecionadoTmpLocal) && isAllSelect(municipioSelecionadoTmpLocal)){
                        //imprimeMensage("passei aqui ", estadoSelecionadoTmp, municipioSelecionadoTmp);
                        carregaDadosEstado(0);
                        setMunicipioSelecionado(t("dashboard.todos"));
                        localStorage.setItem('estadoSelecionadoDashboard', t("dashboard.todos"));
                        localStorage.setItem('codibgeMunicipioSelecionadoDashboard', 0);
                        localStorage.setItem('municipioSelecionadoDashboard', t("dashboard.todos"));
                    } else if(!isAllSelect(municipioSelecionadoTmpLocal)){
                        //imprimeMensage("passei aqui 2", estadoSelecionadoTmp, municipioSelecionadoTmp);
                        let siglaEstado = "";
                        let codigo_estado= "";
                        if(shapeFileBrasil.current !== null){
                            Object.keys(shapeFileBrasil.current["_layers"]).forEach((shape) => {
                          
                                if(isAllSelect(estadoSelecionadoTmpLocal)){
                                    shapeFileBrasil.current["_layers"][shape].setStyle({ weight: weightNormal, color: /*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaBrasilWhite*/transparenciaDefaultMapa, fillColor: /*'#E63100'*//*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaWhite*/ transparenciaDefaultMapa, fillOpacity: 0.5 });
                                } else
                                if(shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["NM_UF"] === estadoSelecionadoTmpLocal){ 
                                    map.current.fitBounds(shapeFileBrasil.current["_layers"][shape].getBounds().pad(1));
                                    siglaEstado = shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["SIGLA_UF"];
                                    codigo_estado = shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["CD_UF"];
                                    shapeFileBrasil.current["_layers"][shape].setStyle({ weight: 2, color: "black" /*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaWhite*//*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaBrasilWhite/*transparenciaDefaultMapa*/, fillColor: /*'#E63100'*//*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaWhite*/ transparenciaDefaultMapa, fillOpacity: 0.5 });
                                } else {
                                    shapeFileBrasil.current["_layers"][shape].setStyle({ weight: weightNormal, color: /*transparenciaDefaultMapa*/"black", fillColor: /*transparenciaDefaultMapa*/ "black", fillOpacity: transparencia.current });   
                                }
                            });
                            
                        }

                        if(shapeFileMunicipios.current !== null){
                            Object.keys(shapeFileMunicipios.current["_layers"]).forEach((shape) => {
                                let corBordaAnt = shapeFileMunicipios.current["_layers"][shape]["options"]["color"];
                                if(corBordaAnt === "#dddcdf"){
                                    corBordaAnt = "black"; 
                                }
                                if(shapeFileMunicipios.current["_layers"][shape]["feature"]["properties"]["NM_MUN"] === municipioSelecionadoTmpLocal){
                                    shapeFileMunicipios.current["_layers"][shape].setStyle({ weight: weightSelecao, color: "black", fillColor: /*transparenciaDefaultMapa*/"black", fillOpacity: 0.5 });
                                    map.current.fitBounds(shapeFileMunicipios.current["_layers"][shape].getBounds().pad(1));
                                } else {
                                    shapeFileMunicipios.current["_layers"][shape].setStyle({ weight: weightNormal, color: corBordaAnt, fillOpacity: 1.0 });   
                                }
                            });
                        }
        
                        
        
                        //imprimeMensage("useEffect cod_ibge, dataSelecionada, dados_totais", codigo_estado, siglaEstado);
                        carregaDadosEstado(codigo_estado, siglaEstado);
                        setEstadoSelecionado(estadoSelecionadoTmpLocal);
                        
                        setCod_Ibge(cod_ibge_tmp);
                        setMunicipioSelecionado(municipioSelecionadoTmpLocal);
                    }
                    setCarregouCache(true);
                } else        
                if (isAllSelect(estadoSelecionado) && isAllSelect(municipioSelecionado)) {
        
                    //setPopulacao("0");
                    //imprimeMensage("0");
        
                    let codigo_estado = 0;
        
                    carregaDadosEstado(codigo_estado);
                    setMunicipioSelecionado(t("dashboard.todos"));
                } 
        
                if(carregouCache && estadoSelecionado !== "" && municipioSelecionado !== "" && estadoSelecionado !== null && municipioSelecionado !== null){
                    //imprimeMensage("carregouCache", estadoSelecionado, municipioSelecionado);
                    localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
                    localStorage.setItem('codibgeMunicipioSelecionadoDashboard', cod_ibge);
                    localStorage.setItem('municipioSelecionadoDashboard', municipioSelecionado);
                }
        
                setFiltrandoMunicipio(false);
                carregandoEstado.current = false;
                
            };

    useEffect(() => {
        if(!dadosCarregados)
            return;
        
        if (shapeFileBrasil.current === null) {
            shapeFileBrasil.current = L.geoJSON(geojsonBrasil, {
                interactive: false,
                style: function (feature) {
                    return { color: "black", fillColor: transparenciaDefaultMapa, stroke: true, weight: weightNormal, fillOpacity: transparencia.current };
                },
                /*onEachFeature: onEachFeatureBrasil,*/
            });
        }

        if (shapeFileMunicipios.current === null) {
            shapeFileMunicipios.current = L.geoJSON(geojsonMunicipios, {
                style: function (feature) {
                    return { color: "gray", fillColor: transparenciaDefaultMapa, stroke: true, weight: weightNormal, fillOpacity: opacidadeMunicipio };
                },
                onEachFeature: onEachFeatureEstado,
            });
        }

        if (map.current !== null) {
            map.current.addLayer(shapeFileBrasil.current);
            map.current.addLayer(shapeFileMunicipios.current);
        }

        carregaCache();
        
    }, [dadosCarregados]);

    /*Variáveis de Data*/
    const [semanaSelecionada, setSemanaSelecionada] = useState(0);
    const [inicioSemanaSelecionada, setInicioSemanaSelecionada] = useState(null);
    const [fimSemanaSelecionada, setFimSemanaSelecionada] = useState(null);
    const [inicioSemanaSelecionadaRange, setInicioSemanaSelecionadaRange] = useState(null);
    const [fimSemanaSelecionadaRange, setFimSemanaSelecionadaRange] = useState(null);
    const [semanas, setSemanas] = useState([]);
    const [inicioSemanas, setInicioSemanas] = useState([]);
    const [fimSemanas, setFimSemanas] = useState([]);
    const [idxDataSelecionada, setIdxDataSelecionada] = useState(0);
    const [dataSelecionada, setDataSelecionada] = useState(0);
    const [minDate, setMinDate] = useState(null);
    const [minDateRangeInicial, setMinDateRangeInicial] = useState(null);
    const [minDateRangeFinal, setMinDateRangeFinal] = useState(null);
    const [minIdxDate, setMinIdxDate] = useState(0);
    const [maxDate, setMaxDate] = useState(null);
    const [maxDateRangeInicial, setMaxDateRangeInicial] = useState(null);
    const [maxDateRangeFinal, setMaxDateRangeFinal] = useState(null);
    const [maxIdxDate, setMaxIdxDate] = useState(0);
    const [datas, setDatas] = useState([]);
    const [maxLengthData, setMaxLengthData] = useState(0);
    const [dados_municipios, setDados_Municipios] = useState(null);
    /*Fim Variáveis de Data*/

    const [listaColorMap, setListaColorMap] = useState([
        {"value": "gray", "nome":  "Gray"},
        {"value": "jet", "nome": "Jet"},
        {"value": "rainbow", "nome": "Rainbow"},
        {"value": "gist_rainbow", "nome": "Gist Rainbow"},
        {"value": "hot", "nome": "Hot"},
        {"value": "brg", "nome": "brg"},
        {"value": "seismic", "nome": "seismic"},
        {"value": "cyan_light_to_blue_dark", "nome": "Cyan Light to Blue Dark"},
    ]);

    const [listaVariaveisClima, setListaVariaveisClima] = useState([
        {"value":"Bio01_BR", "nome": t("dashboard.variaveisClima.Bio01BR")},
        {"value":"Bio02_BR", "nome": t("dashboard.variaveisClima.Bio02BR")},
        {"value":"Bio03_BR", "nome": t("dashboard.variaveisClima.Bio03BR")},
        {"value":"Bio04_BR", "nome": t("dashboard.variaveisClima.Bio04BR")},
        {"value":"Bio05_BR", "nome": t("dashboard.variaveisClima.Bio05BR")},
        {"value":"Bio06_BR", "nome": t("dashboard.variaveisClima.Bio06BR")},
        {"value":"Bio07_BR", "nome": t("dashboard.variaveisClima.Bio07BR")},
        {"value":"Bio08_BR", "nome": t("dashboard.variaveisClima.Bio08BR")},
        {"value":"Bio09_BR", "nome": t("dashboard.variaveisClima.Bio09BR")},
        {"value":"Bio10_BR", "nome": t("dashboard.variaveisClima.Bio10BR")},
        {"value":"Bio11_BR", "nome": t("dashboard.variaveisClima.Bio11BR")},
        {"value":"Bio12_BR", "nome": t("dashboard.variaveisClima.Bio12BR")},
        {"value":"Bio13_BR", "nome": t("dashboard.variaveisClima.Bio13BR")},
        {"value":"Bio14_BR", "nome": t("dashboard.variaveisClima.Bio14BR")},
        {"value":"Bio15_BR", "nome": t("dashboard.variaveisClima.Bio15BR")},
        {"value":"Bio16_BR", "nome": t("dashboard.variaveisClima.Bio16BR")},
        {"value":"Bio17_BR", "nome": t("dashboard.variaveisClima.Bio17BR")},
        {"value":"Bio18_BR", "nome": t("dashboard.variaveisClima.Bio18BR")},
        {"value":"Bio19_BR", "nome": t("dashboard.variaveisClima.Bio19BR")},
    ]);

    let corTemperatura = "jet";
    let corUmidadePrecipitacao = "cyan_light_to_blue_dark";

    var tipoEscala = [
        {"nome" : "Bio01_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio02_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio03_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio04_BR", "tipo" : "ºC/100", "colormap" : corTemperatura},
        {"nome" : "Bio05_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio06_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio07_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio08_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio09_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio10_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio11_BR", "tipo" : "ºC", "colormap" : corTemperatura},
        {"nome" : "Bio12_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio13_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio14_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio15_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio16_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio17_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio18_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao},
        {"nome" : "Bio19_BR", "tipo" : "kg m-2", "colormap" : corUmidadePrecipitacao}
    ];

    const [variavel, setVariavel] = useState("Bio01_BR");    

    const legend = useRef(null);

    var layer_ = useRef(null);

    const geoRaster = useRef(null);
    
    const [dados_municipio_selecionado, setDados_Municipio_Selecionado] = useState(null);

    const min = useRef(0);
    const max = useRef(0);
    const range = useRef(0);
    
    posicao = localStorage.getItem('posicaoScroll');
    var nomes_estados = [];//(require('./Dados/estados.json'));

    //refs mapa
    const layerTile = useRef(null);
    const layerControl = useRef(null);
    let map = useRef(null);

    //refs shapefiles
    const shapeFileBrasil = useRef(null);
    const shapeFileMunicipios = useRef(null);

    const iniciou = useRef(false);

    function CheckError(response) {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          throw Error(response.statusText);
        }
    }

    const getSemana = () => {
        return;
        fetch('dados_semanas.json?' + dataDados
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        )
        .then(CheckError)
        .then(function (myJson) {
            semanas_epidemiologicas.current = myJson;                
        });
    }

    function getOptions_Line(theme, perc, titulo){    
        return {
          responsive: isResponsive,
          maintainAspectRatio: maintainAspectRatio,
          layout:{
            padding: {
                left: leftGrafico,
                right: rightGrafico,
                top: topGrafico,
                bottom: bottomGrafico
            }
          },
          plugins: {
              annotation: {
                  annotations: [
                    {
                      type: 'line',
                      mode: 'vertical',
                      scaleID: 'x',
                      value: dataSelecionada,
                      borderColor: corLinhaMarcaoGrafico,
                      borderWidth: 1,
                    },
                  ],
                },
            tooltip: {
              callbacks: {
                /*label: context => {
                  context["formattedValue"] = perc ? fixaCasasDecimais(context["formattedValue"],2) + "%" : context["formattedValue"];
                  if(context["element"]["options"]["backgroundColor"] === "rgba(255, 255, 255, 1)")
                    return "";
  
                  return getDataLabelGrafico(context);
                }*/
              }
            },
            legend: {
              display: true,
              onClick: null,
              position: 'bottom',
              align: 'start',
              labels: {
                boxWidth: 15,
                color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
                font: { 
                  size: 10
                }
              }
            },
            title: {
              display: false,
              text: titulo,
              color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
              position: 'top',
              font:{
                size: 13
              }
            },
          },
          scales: {
            y: {  // not 'yAxes: [{' anymore (not an array anymore)  
                position: 'left',
                ticks: {
                    color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
                    // fontSize: 18,
                    font: {
                      size: fontGrafico, // 'size' now within object 'font {}'
                    },
                    //stepSize: passo,
                    callback: function(value, index, ticks) {
                      return value + (perc ? '%' : '');
                    }
                  },
              /*ticks: {
                color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
                // fontSize: 18,
                font: {
                  size: fontGrafico, // 'size' now within object 'font {}'
                },
                //stepSize: passo,
                beginAtZero: false,
                callback: function(value, index, ticks) {
                  return value + (perc === true ? '%' : '');
                }
              },*/
              beginAtZero: false,
            }, 
            y2: {  // not 'yAxes: [{' anymore (not an array anymore) 
                position: 'right', 
                ticks: {
                    color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
                    // fontSize: 18,
                    font: {
                      size: fontGrafico, // 'size' now within object 'font {}'
                    },
                    //stepSize: passo,
                    callback: function(value, index, ticks) {
                      return value;
                    }
                  },
                /*ticks: {
                  color: theme === "dark" ? texto_grafico_dark : texto_grafico_light, // not 'fontColor:' anymore
                  // fontSize: 18,
                  font: {
                    size: fontGrafico, // 'size' now within object 'font {}'
                  },
                  //stepSize: passo,
                  beginAtZero: false,
                  callback: function(value, index, ticks) {
                    return value + (perc === true ? '%' : '');
                  }
                },
                beginAtZero: false,*/
              },
            x: {  
                type: 'time',
                time: {
                  parser: 'YYYY/MM/DD',
                  unit: 'day',
                  displayFormats: {
                    'day': 'DD/MM/YYYY',
                    'month' : 'DD/MM/YYYY'
                  },
                },
                ticks:{
                  color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
                  font: {
                    size: fontGrafico, // 'size' now within object 'font {}'
                  },
                  //stepSize: 7,
                  callback: function(value, index, values) {
                      
                      return exibeMesAnoGrafico(index, values);
                      
                  },
                },
                min: datas != null ? datas[minIdxDate] : null,
                max: datas != null ? datas[maxIdxDate] : null,
              }
            /*x: {  // not 'xAxes: [{' anymore (not an array anymore)
              type: 'time',
              time: {
                parser: 'YYYY/MM/DD',
                unit: 'day',
                displayFormats: {
                 'day': 'DD/MM/YYYY',
                 'month' : 'DD/MM/YYYY'
                },
                
              },
              ticks:{
                color: theme === "dark" ? texto_grafico_dark : texto_grafico_light,
                font: {
                  size: fontGrafico, // 'size' now within object 'font {}'
                },
                //stepSize: 7,
                callback: function(value, index, values) {
                    
                    return exibeMesAnoGrafico(index, values);
                },
              },
              min: datas != null ? datas[minIdxDate] : null,
              max: datas != null ? datas[maxIdxDate] : null,
            }*/
          }
          
        }
    }

    const handleChangeSelectData = (event) => {
        if(event.target.value > (datas.length -1)){
            setIdxDataSelecionada(datas.length -1);
            setDataSelecionada(datas[datas.length -1]);
            setSemanaSelecionada(semanas[semanas.length -1]);
            setInicioSemanaSelecionada(inicioSemanas[inicioSemanas.length -1]);
            setFimSemanaSelecionada(fimSemanas[fimSemanas.length -1]);
        } else {
            setIdxDataSelecionada(event.target.value);
            setDataSelecionada(datas[event.target.value]);
            setSemanaSelecionada(semanas[event.target.value]);
            setInicioSemanaSelecionada(inicioSemanas[event.target.value]);
            setFimSemanaSelecionada(fimSemanas[event.target.value]);
        }
    };

    const mudarData = (idx, datas_local) => {
        setLoading(true);
        if (alterandoData && !datas_local)
            return;

        if (idx > datas_local.length - 1) {
            idx = 0;
        } else if (idx < 0) {
            idx = datas_local.length - 1;
        }

        if(map.current  !== null)
            map.current.closePopup();

        alterandoData = true;

        setIdxDataSelecionada(idx);
        setDataSelecionada(datas_local[idx]);
        setSemanaSelecionada(semanas[idx]);
        setInicioSemanaSelecionada(inicioSemanas[idx]);
        setFimSemanaSelecionada(fimSemanas[idx]);

        alterandoData = false;
    }

    function getCidades(somenteNomes) {
        var nomes_municipios = [];

        if(somenteNomes){
            nomes_municipios.unshift(
                t("dashboard.todos")
            );
            nomes_municipios.sort((a, b) => a.localeCompare(b));
        } else {
            nomes_municipios.unshift({
                "cod_ibge": 0,
                "municipio": t("dashboard.todos")
            });
            nomes_municipios.sort((a, b) => a["municipio"].localeCompare(b["municipio"]));
        }

        return nomes_municipios;
    }

    const getEstados = () => { 
        let nomes_estados_tmp = [];

        fetch(servidor + '/api/estado', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + _logado
            }
        }).then(response => {
            if (response.status === 401  || response.status === 404) {
                setLogado(null);    
                window.location.href = "/";
            }
            return response.json();
        })
        .then(data => {
            for (let i=0; i < data.length; i++){
                nomes_estados_tmp.push(data[i]);
            }
      
        }).catch(error => {
            console.error('Erro ao carregar o arquivo JSON:', error);
        });
        
        
        nomes_estados_tmp.unshift({
            "UF": "All",
            "ESTADO": t("dashboard.todos")
        });         
        
        return nomes_estados_tmp;
    }

    const [loading, setLoading] = useState(true);
    const [cod_ibge, setCod_Ibge] = useState(t("dashboard.todos"));
    const [municipioSelecionado, setMunicipioSelecionado] = useState(t("dashboard.todos"));
    const [estadoSelecionado, setEstadoSelecionado] = useState(t("dashboard.todos"));
    const [listaMunicipios, setListaMunicipios] = useState(getCidades());
    //const [listaEstados, setListaEstados] = useState(getEstados());
    const [listaSinaisAviso, setlistaSinaisAviso] = useState(
        [
            {"sinal": "EVI", "nome":  t("dashboard.evi_simples")},
            {"sinal": "Ears", "nome": t("dashboard.ears")},
            {"sinal": "MMAING", "nome": "MMAING"},
            {"sinal": "GLM", "nome": "GLM"},
            {"sinal": "ENS", "nome": t("dashboard.table.ens")},
        ]);
    const [filtroDQIMapa, setFiltroDQIMapa] = useState(t("dashboard.apto"));
    const [cidades_labels, setCidades_Labels] = useState([{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}]);
    const [mapa_cor_value, setMapa_Cor_Value] = useState("jet");

    const [dados_Municipio, setDados_Municipio] = useState(null);

    const [ultimoValorTEMP, setUltimoValorTEMP] = useState(null);
    const [ultimoValorUM, setUltimoValorUM] = useState(null);
    const [ultimoValorPREC, setUltimoValorPREC] = useState(null);

    const [municipiosTodosEstados, setMunicipiosTodosEstados] = useState(null);

    const [dataCache, setDataCache] = useState(null);

    let link_gripe = "";
    const [link_zika, setLink_Zika] = useState(null);
    let dengue = true;
    
    const defaultPropsMunicipio = {
        options: cidades_labels,
        getOptionLabel: (option) => option.label,
    };

    const isAllSelect = (variavel) => {
        return variavel === "All" || variavel === "Todos";
    }

    useEffect(() => {
        if(shapeFileMunicipios.current != null)
            plotaMapa();

        if(!isAllSelect(cod_ibge)){
            //let arquivo = "Dados/climatico/dados/climatico_"+cod_ibge+".json";
            //let arquivo = "Dados/climatico/dados_new/dados_clima_"+cod_ibge.substring(0,6)+".json";
            
            //console.log(arquivo);

            fetch(servidor + "/api/climate/municipio/"+cod_ibge, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + _logado
                }
            })
            .then(response => {
                if (response.status === 401  || response.status === 404) {
                    setLogado(null);    
                    window.location.href = "/";
                }
                return response.json();
            })
            .then(data => {
                setDados_Municipio(data); // Atribui os dados JSON à variável global
            }
            ).catch(error => {
                alert("Arquivo correspondente não encontrado !");
                console.error('Erro ao carregar o arquivo JSON:', error);
                setDados_Municipio(null);
            });
        } else {
            setDados_Municipio(null);
        }
    }, [cod_ibge]);

    function converterDiaDoAnoParaData(ano, diaDoAno) {
        var data = new Date(ano, 0); // Inicia em 0 (janeiro)
        data.setDate(diaDoAno); // Define o dia do ano
        
        // Formata a data para um formato legível
        var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        var dataFormatada = data.toLocaleDateString('pt-BR', options);
        
        return dataFormatada;
    }

    useEffect(() => {
        if(mapa_cor_value != null){
            let colormap = getColorMap(mapa_cor_value);
            
            if(layer_.current !== null){
                layer_.current.updateColors(function(pixelValues) {
                    var pixelValue = pixelValues[0];

                    if (pixelValue === 0 || pixelValue === -3.3999999521443642e+38) return null;

                    var scaledPixelValue = (pixelValue - min.current) / range.current;

                    var color_ = colormap(scaledPixelValue).hex();

                    
                    return color_;
                });
                
                preparaColorMap();
            }
        }
    }, [mapa_cor_value]);

    useEffect(() => {
        if(dados_municipios === null)
            return;   

        let datasTemp = [];
        let semanasTemp = [];
        let inicioSemanasTemp = [];
        let fimSemanasTemp = [];
        
        let dados_totais_local = [];

        dados_municipios.forEach(function (atendimento) {
            var obj = {};
            datasTemp.push(atendimento["data"]);
            semanasTemp.push(atendimento["semana"]);
            inicioSemanasTemp.push(atendimento["data_inicial_semana"]);
            fimSemanasTemp.push(atendimento["data_final_semana"]);
            obj = {
                "date": atendimento["data"],
                "total_geral": atendimento["total_geral"],
                "total_gripal": atendimento["total_gripal"],
                "media_movel": atendimento["media_movel_ivas"],
                "variacao_media_movel": atendimento["variacao_media_movel"],
                "mu": indice.toLowerCase() === "mmaing" ? atendimento["lim_esp_ml_ivas"] : indice.toLowerCase() === "ens" ? atendimento["lim_esp_ens_ivas"] : indice.toLowerCase() === "evi" ? atendimento["lim_esp_evi_ivas"] : indice.toLowerCase() === "ears" ? atendimento["lim_esp_ears_ivas"] : atendimento["lim_esp_glm_ivas"],
                "exc": indice.toLowerCase() === "mmaing" ? fixaCasasDecimais(atendimento["exc_ml_ivas"], 2) : indice.toLowerCase() === "ens" ? fixaCasasDecimais(atendimento["exc_ens_ivas"], 2) : indice.toLowerCase() === "evi" ? fixaCasasDecimais(atendimento["exc_evi_ivas"], 2) : indice.toLowerCase() === "ears" ? fixaCasasDecimais(atendimento["exc_ears_ivas"], 2) : fixaCasasDecimais(atendimento["exc_glm_ivas"], 2),
                "exc_ambos": fixaCasasDecimais(atendimento["exc_ambos_ivas"], 2) ,
                "exc_evi": fixaCasasDecimais(atendimento["exc_evi_ivas"], 2) ,
                "exc_ears": fixaCasasDecimais(atendimento["exc_ears_ivas"], 2) ,
                "exc_ens": fixaCasasDecimais(atendimento["exc_ens_ivas"], 2) ,
                "exc_ml": fixaCasasDecimais(atendimento["exc_ml_ivas"], 2) ,
            };
            var busca = dados_totais_local.find(dt => dt["date"] === obj["date"]);

            if (busca != null) {
                teste_data = obj["date"];
                obj["total_geral"] = obj["total_geral"] + busca["total_geral"];
                obj["total_gripal"] = obj["total_gripal"] + busca["total_gripal"];
                obj["media_movel"] = obj["media_movel"] + busca["media_movel"];
                obj["variacao_media_movel"] = obj["variacao_media_movel"] + busca["variacao_media_movel"];
                obj["mu"] = obj["mu"] + busca["mu"];
                obj["exc"] = obj["exc"] + busca["exc"];

                obj["exc_ambos"] = obj["exc_ambos"] + busca["exc_ambos"];
                obj["exc_evi"] = obj["exc_evi"] + busca["exc_evi"];
                obj["exc_ears"] = obj["exc_ears"] + busca["exc_ears"];
                obj["exc_ens"] = obj["exc_ens"] + busca["exc_ens"];
                obj["exc_ml"] = obj["exc_ml"] + busca["exc_ml"];

                var idx = dados_totais_local.findIndex(checkDado);
                dados_totais_local[idx] = obj;
            } else {
                dados_totais_local.push(obj);
            }
        });

        //setDados_Totais(dados_totais_local);

        setDatas(datasTemp);

        setSemanas(semanasTemp);

        setInicioSemanas(inicioSemanasTemp);
        setFimSemanas(fimSemanasTemp);

        setMaxLengthData(datasTemp.length);

        /*setMinDate(datasTemp[0]);
        setMinIdxDate(0);
        setMaxDate(datasTemp[datasTemp.length - 1]);
        setMaxIdxDate(datasTemp.length - 1);*/

        //getDadosPorData(datasTemp[idxDataInicio], language, true);

        mudarData(datasTemp.length - 1, datasTemp);
        
    
    }, [dados_municipios]);

    const getNomeCidadeWhereCodIbge = (cod_ibge_local) => {
        let retorno = null;
        if(isNumeric(cod_ibge_local)){
            const keys = Object.keys(shapeFileMunicipios.current["_layers"]);
            if (keys.length > 0) {
                for (let index = 0; index < keys.length; index++) {
                    const key = keys[index];
                    const elementLoop = shapeFileMunicipios.current["_layers"][key];
                    if(elementLoop !== undefined){
                        let cod_temp = parseInt(elementLoop["feature"]["properties"]["CD_MUN"]);
                        if(elementLoop["feature"]["properties"]["CD_MUN"] === cod_ibge_local || cod_temp === cod_ibge_local){
                            retorno =  elementLoop["feature"]["properties"]["NM_MUN"];
                            break;
                        }
                    } else {
                        retorno = cod_ibge_local;
                    }
                }
            } 
        }
        else {
            retorno = cod_ibge_local;
        }
        return retorno;
    }

    const getCodIbgeShapefile = (shapefile, shape) => {
        let valor = shapefile["_layers"][shape]["feature"]["properties"]["CD_MUN"];
        if(typeof shapefile["_layers"][shape]["feature"]["properties"]["CD_MUN"] === "number"){
            valor = shapefile["_layers"][shape]["feature"]["properties"]["CD_MUN"].toString();
        }
        return (valor);
    }

    const handleChangeMunicipioNome = (nome_municipio) => {
        if (map.current !== null)
            map.current.closePopup();

        //console.log("handleChangeMunicipioNome: ");

        if(isAllSelect(nome_municipio)){
            Object.keys(shapeFileMunicipios.current["_layers"]).forEach((shape) => {
                let corBordaAnt = shapeFileMunicipios.current["_layers"][shape]["options"]["color"];
                if(corBordaAnt === "#dddcdf"){
                    corBordaAnt = "black"; 
                }
                shapeFileMunicipios.current["_layers"][shape].setStyle({ weight: weightNormal, color: corBordaAnt, fillOpacity: 1.0 });
            });

            setCod_Ibge(nome_municipio);
            setMunicipioSelecionado(getNomeCidadeWhereCodIbge(nome_municipio));
            setDados_Municipio_Selecionado(null);
            localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
            localStorage.setItem('codibgeMunicipioSelecionadoDashboard', t("dashboard.todos"));
            localStorage.setItem('municipioSelecionadoDashboard', t("dashboard.todos"));
        } else {
            setCod_Ibge(nome_municipio);
            setMunicipioSelecionado(getNomeCidadeWhereCodIbge(nome_municipio));
            localStorage.setItem('estadoSelecionadoDashboard', estadoSelecionado);
            localStorage.setItem('codibgeMunicipioSelecionadoDashboard', nome_municipio);
            localStorage.setItem('municipioSelecionadoDashboard', getNomeCidadeWhereCodIbge(nome_municipio));
            //console.log(estadoSelecionado, nome_municipio, getNomeCidadeWhereCodIbge(nome_municipio));
            
            const keys = Object.keys(shapeFileMunicipios.current["_layers"]);
            if (keys.length > 0) {
                for (let index = 0; index < keys.length; index++) {
                    const key = keys[index];
                    const elementLoop = shapeFileMunicipios.current["_layers"][key];
                    if (nome_municipio === getCodIbgeShapefile(shapeFileMunicipios.current, key)) {
                        map.current.fitBounds(elementLoop.getBounds().pad(1));
                        break;
                    }
                }
            } 
        }
    };

    var estados_labels = [
        {label:t("dashboard.todos")},
        {label:"Acre"},
        {label:"Alagoas"},
        {label:"Amapá"},
        {label:"Amazonas"},
        {label:"Bahia"},
        {label:"Ceará"},
        {label:"Distrito Federal"},
        {label:"Espírito Santo"},
        {label:"Goiás"},
        {label:"Maranhão"},
        {label:"Mato Grosso"},
        {label:"Mato Grosso do Sul"},
        {label:"Minas Gerais"},
        {label:"Pará"},
        {label:"Paraíba"},
        {label:"Paraná"},
        {label:"Pernambuco"},
        {label:"Piauí"},
        {label:"Rio de Janeiro"},
        {label:"Rio Grande do Norte"},
        {label:"Rio Grande do Sul"},
        {label:"Rondônia"},
        {label:"Roraima"},
        {label:"Santa Catarina"},        
        {label:"São Paulo"},
        {label:"Sergipe"},
        {label:"Tocantins"},
    ];

    var defaultProps = {
        options: estados_labels,
        getOptionLabel: (option) => option.label,
    };

    var zoomPorClique = false;

    useEffect(() => {     
        /*if (!logado) {
            navigate("/");
            return;
        }*/

        loadGeoJSONData();

        _logado = logado;

        if(CookieService.getCookie("hashCache")){
            _logado = CookieService.getCookie("hashCache");
           // console.log("logado", _logado, logado);
        } else {
            console.log("retornando a principal");
            navigate("/");
            return;
        }

        var dominio = window.location.hostname;


        //// Use fetch para carregar o arquivo JSON
        fetch(servidor + '/api/dadosdoenca/pais/1', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + _logado
        }})
        .then(response => {
            if (response.status === 401  || response.status === 404) {
                setLogado(null);    
                window.location.href = "/";
            }
            return response.json();
        })
        .then(data => {
            setDados_Municipios(data); // Atribui os dados JSON à variável global
        })
        .catch(error => {
            console.error('Erro ao carregar o arquivo JSON:', error);
        });

        getSemana();

        iniciou.current = true;
        localStorage.setItem('posicaoScroll', JSON.stringify(0));
        //getDadosPorData(datas[idxDataSelecionada], language, true);
        //setDados_Municipios(dados_municipios_semanal);  

        //crie um for que itere sobre todos os uf e crie um arquivo json para cada um
        let todosEstados = [];
        cod_estados.forEach(function (estado) {
            //console.log(estado);
            fetch(servidor + '/api/municipio/municipiosbysiglaestado/' + estado["UF"]
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + _logado
                    }
                }
            )
            .then(response => {
                if (response.status === 401  || response.status === 404) {
                    setLogado(null);    
                    window.location.href = "/";
                }
                return response.json();
            })
            .then(function (myJson) {
                //console.log(myJson);
                let cidades_labels_tmp = [{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}];
                for(let i = 0; i < myJson.length; i++){
                    todosEstados.push({
                        "cod_ibge": myJson[i]["cod_ibge"],
                        "municipio": myJson[i]["municipio"],
                        "latitude": myJson[i]["y"],
                        "longitude": myJson[i]["x"]
                    }); 
                }
    
                todosEstados.sort((a, b) => a["municipio"].localeCompare(b["municipio"]));
                
                //console.log("Terminou");
                //getDadosPorData(datas[idxDataSelecionada], language, true);
            })
            .catch(err => {
                console.error("Erro capturado 1:", err);
                debugger; // para pausar e inspecionar
            });
        });

        todosEstados.unshift({
            "cod_ibge": 0,
            "municipio": t("dashboard.todos")
        });

        setMunicipiosTodosEstados(todosEstados);

        //console.log("carrega dataCacheFiles");
        setDataCache(localStorage.getItem('dataCacheFiles')); 
        //console.log("fim carrega dataCacheFiles");

        var dominio = window.location.hostname;

        if(dominio.includes("arbov")){
            dengue = false;
        } else {
            dengue = true;
        }

        /*if(dominio.includes("aesopdev")){
            setLink_Zika("https://aesoparbovdev.outerlamce.com/");
        } else if(dominio.includes("testeaesop.")) {
            setLink_Zika("https://testeaesoparbov.outerlamce.com/");
        } else {
            setLink_Zika("https://aesoparbov.outerlamce.com/");
        }*/
        const baseUrl = window.location.origin;
        const arbovUrl = `${baseUrl}/arbov`;
        setLink_Zika(arbovUrl);

        if(dominio.includes("aesoparbovdev")){
            link_gripe = "https://aesopdev.outerlamce.com/";
        } else if(dominio.includes("teste")) {
            link_gripe = "https://testeaesop.outerlamce.com/";
        } else {
            link_gripe = "https://aesop.outerlamce.com/";
        }

    }, []);

    /*colormaps*/
    var color_scale_jet = chroma.scale(['#000080', '#000084', '#000089', '#00008d', '#000092', '#000096', '#00009b', '#00009f', '#0000a4', '#0000a8', '#0000ad', '#0000b2', '#0000b6', '#0000bb', '#0000bf', '#0000c4', '#0000c8', '#0000cd', '#0000d1', '#0000d6', '#0000da', '#0000df', '#0000e3', '#0000e8', '#0000ed', '#0000f1', '#0000f6', '#0000fa', '#0000ff', '#0000ff', '#0000ff', '#0000ff', '#0000ff', '#0004ff', '#0008ff', '#000cff', '#0010ff', '#0014ff', '#0018ff', '#001cff', '#0020ff', '#0024ff', '#0028ff', '#002cff', '#0030ff', '#0034ff', '#0038ff', '#003cff', '#0040ff', '#0044ff', '#0048ff', '#004cff', '#0050ff', '#0054ff', '#0058ff', '#005cff', '#0060ff', '#0064ff', '#0068ff', '#006cff', '#0070ff', '#0074ff', '#0078ff', '#007cff', '#0080ff', '#0084ff', '#0088ff', '#008cff', '#0090ff', '#0094ff', '#0098ff', '#009cff', '#00a0ff', '#00a4ff', '#00a8ff', '#00acff', '#00b0ff', '#00b4ff', '#00b8ff', '#00bcff', '#00c0ff', '#00c4ff', '#00c8ff', '#00ccff', '#00d0ff', '#00d4ff', '#00d8ff', '#00dcfe', '#00e0fb', '#00e4f8', '#02e8f4', '#06ecf1', '#09f0ee', '#0cf4eb', '#0ff8e7', '#13fce4', '#16ffe1', '#19ffde', '#1cffdb', '#1fffd7', '#23ffd4', '#26ffd1', '#29ffce', '#2cffca', '#30ffc7', '#33ffc4', '#36ffc1', '#39ffbe', '#3cffba', '#40ffb7', '#43ffb4', '#46ffb1', '#49ffad', '#4dffaa', '#50ffa7', '#53ffa4', '#56ffa0', '#5aff9d', '#5dff9a', '#60ff97', '#63ff94', '#66ff90', '#6aff8d', '#6dff8a', '#70ff87', '#73ff83', '#77ff80', '#7aff7d', '#7dff7a', '#80ff77', '#83ff73', '#87ff70', '#8aff6d', '#8dff6a', '#90ff66', '#94ff63', '#97ff60', '#9aff5d', '#9dff5a', '#a0ff56', '#a4ff53', '#a7ff50', '#aaff4d', '#adff49', '#b1ff46', '#b4ff43', '#b7ff40', '#baff3c', '#beff39', '#c1ff36', '#c4ff33', '#c7ff30', '#caff2c', '#ceff29', '#d1ff26', '#d4ff23', '#d7ff1f', '#dbff1c', '#deff19', '#e1ff16', '#e4ff13', '#e7ff0f', '#ebff0c', '#eeff09', '#f1fc06', '#f4f802', '#f8f500', '#fbf100', '#feed00', '#ffea00', '#ffe600', '#ffe200', '#ffde00', '#ffdb00', '#ffd700', '#ffd300', '#ffd000', '#ffcc00', '#ffc800', '#ffc400', '#ffc100', '#ffbd00', '#ffb900', '#ffb600', '#ffb200', '#ffae00', '#ffab00', '#ffa700', '#ffa300', '#ff9f00', '#ff9c00', '#ff9800', '#ff9400', '#ff9100', '#ff8d00', '#ff8900', '#ff8600', '#ff8200', '#ff7e00', '#ff7a00', '#ff7700', '#ff7300', '#ff6f00', '#ff6c00', '#ff6800', '#ff6400', '#ff6000', '#ff5d00', '#ff5900', '#ff5500', '#ff5200', '#ff4e00', '#ff4a00', '#ff4700', '#ff4300', '#ff3f00', '#ff3b00', '#ff3800', '#ff3400', '#ff3000', '#ff2d00', '#ff2900', '#ff2500', '#ff2200', '#ff1e00', '#ff1a00', '#ff1600', '#ff1300', '#fa0f00', '#f60b00', '#f10800', '#ed0400', '#e80000', '#e40000', '#df0000', '#da0000', '#d60000', '#d10000', '#cd0000', '#c80000', '#c40000', '#bf0000', '#bb0000', '#b60000', '#b20000', '#ad0000', '#a80000', '#a40000', '#9f0000', '#9b0000', '#960000', '#920000', '#8d0000', '#890000', '#840000', '#800000']);
    var color_scale_gray = chroma.scale(['#000000', '#010101', '#020202', '#030303', '#040404', '#050505', '#060606', '#070707', '#080808', '#090909', '#0a0a0a', '#0b0b0b', '#0c0c0c', '#0d0d0d', '#0e0e0e', '#0f0f0f', '#101010', '#111111', '#121212', '#131313', '#141414', '#151515', '#161616', '#171717', '#181818', '#191919', '#1a1a1a', '#1b1b1b', '#1c1c1c', '#1d1d1d', '#1e1e1e', '#1f1f1f', '#202020', '#212121', '#222222', '#232323', '#242424', '#252525', '#262626', '#272727', '#282828', '#292929', '#2a2a2a', '#2b2b2b', '#2c2c2c', '#2d2d2d', '#2e2e2e', '#2f2f2f', '#303030', '#313131', '#323232', '#333333', '#343434', '#353535', '#363636', '#373737', '#383838', '#393939', '#3a3a3a', '#3b3b3b', '#3c3c3c', '#3d3d3d', '#3e3e3e', '#3f3f3f', '#404040', '#414141', '#424242', '#434343', '#444444', '#454545', '#464646', '#474747', '#484848', '#494949', '#4a4a4a', '#4b4b4b', '#4c4c4c', '#4d4d4d', '#4e4e4e', '#4f4f4f', '#505050', '#515151', '#525252', '#535353', '#545454', '#555555', '#565656', '#575757', '#585858', '#595959', '#5a5a5a', '#5b5b5b', '#5c5c5c', '#5d5d5d', '#5e5e5e', '#5f5f5f', '#606060', '#616161', '#626262', '#636363', '#646464', '#656565', '#666666', '#676767', '#686868', '#696969', '#6a6a6a', '#6b6b6b', '#6c6c6c', '#6d6d6d', '#6e6e6e', '#6f6f6f', '#707070', '#717171', '#727272', '#737373', '#747474', '#757575', '#767676', '#777777', '#787878', '#797979', '#7a7a7a', '#7b7b7b', '#7c7c7c', '#7d7d7d', '#7e7e7e', '#7f7f7f', '#808080', '#818181', '#828282', '#838383', '#848484', '#858585', '#868686', '#878787', '#888888', '#898989', '#8a8a8a', '#8b8b8b', '#8c8c8c', '#8d8d8d', '#8e8e8e', '#8f8f8f', '#909090', '#919191', '#929292', '#939393', '#949494', '#959595', '#969696', '#979797', '#989898', '#999999', '#9a9a9a', '#9b9b9b', '#9c9c9c', '#9d9d9d', '#9e9e9e', '#9f9f9f', '#a0a0a0', '#a1a1a1', '#a2a2a2', '#a3a3a3', '#a4a4a4', '#a5a5a5', '#a6a6a6', '#a7a7a7', '#a8a8a8', '#a9a9a9', '#aaaaaa', '#ababab', '#acacac', '#adadad', '#aeaeae', '#afafaf', '#b0b0b0', '#b1b1b1', '#b2b2b2', '#b3b3b3', '#b4b4b4', '#b5b5b5', '#b6b6b6', '#b7b7b7', '#b8b8b8', '#b9b9b9', '#bababa', '#bbbbbb', '#bcbcbc', '#bdbdbd', '#bebebe', '#bfbfbf', '#c0c0c0', '#c1c1c1', '#c2c2c2', '#c3c3c3', '#c4c4c4', '#c5c5c5', '#c6c6c6', '#c7c7c7', '#c8c8c8', '#c9c9c9', '#cacaca', '#cbcbcb', '#cccccc', '#cdcdcd', '#cecece', '#cfcfcf', '#d0d0d0', '#d1d1d1', '#d2d2d2', '#d3d3d3', '#d4d4d4', '#d5d5d5', '#d6d6d6', '#d7d7d7', '#d8d8d8', '#d9d9d9', '#dadada', '#dbdbdb', '#dcdcdc', '#dddddd', '#dedede', '#dfdfdf', '#e0e0e0', '#e1e1e1', '#e2e2e2', '#e3e3e3', '#e4e4e4', '#e5e5e5', '#e6e6e6', '#e7e7e7', '#e8e8e8', '#e9e9e9', '#eaeaea', '#ebebeb', '#ececec', '#ededed', '#eeeeee', '#efefef', '#f0f0f0', '#f1f1f1', '#f2f2f2', '#f3f3f3', '#f4f4f4', '#f5f5f5', '#f6f6f6', '#f7f7f7', '#f8f8f8', '#f9f9f9', '#fafafa', '#fbfbfb', '#fcfcfc', '#fdfdfd', '#fefefe', '#ffffff']);
    var color_scale_rainbow = chroma.scale(['#8000ff', '#7e03ff', '#7c06ff', '#7a09ff', '#780dff', '#7610ff', '#7413ff', '#7216ff', '#7019ff', '#6e1cff', '#6c1fff', '#6a22fe', '#6826fe', '#6629fe', '#642cfe', '#622ffe', '#6032fe', '#5e35fe', '#5c38fd', '#5a3bfd', '#583efd', '#5641fd', '#5444fd', '#5247fc', '#504afc', '#4e4dfc', '#4c50fc', '#4a53fb', '#4856fb', '#4659fb', '#445cfb', '#425ffa', '#4062fa', '#3e65fa', '#3c68f9', '#396bf9', '#386df9', '#3670f8', '#3473f8', '#3176f8', '#3079f7', '#2e7bf7', '#2c7ef7', '#2981f6', '#2884f6', '#2686f5', '#2489f5', '#218cf4', '#208ef4', '#1e91f3', '#1c93f3', '#1996f3', '#1898f2', '#169bf2', '#149df1', '#11a0f1', '#10a2f0', '#0ea5ef', '#0ca7ef', '#09a9ee', '#08acee', '#06aeed', '#04b0ed', '#01b3ec', '#00b5eb', '#02b7eb', '#04b9ea', '#07bbea', '#08bee9', '#0ac0e8', '#0dc2e8', '#0fc4e7', '#10c6e6', '#12c8e6', '#14cae5', '#17cbe4', '#18cde4', '#1acfe3', '#1dd1e2', '#1fd3e1', '#20d5e1', '#22d6e0', '#24d8df', '#27dade', '#28dbde', '#2adddd', '#2ddedc', '#2fe0db', '#30e1da', '#32e3da', '#34e4d9', '#37e6d8', '#38e7d7', '#3ae8d6', '#3dead5', '#3febd5', '#40ecd4', '#42edd3', '#44eed2', '#46efd1', '#48f1d0', '#4af2cf', '#4df3ce', '#4ef3cd', '#50f4cc', '#52f5cb', '#54f6cb', '#56f7ca', '#58f8c9', '#5af8c8', '#5df9c7', '#5efac6', '#60fac5', '#62fbc4', '#64fbc3', '#66fcc2', '#68fcc1', '#6afdc0', '#6dfdbf', '#6efebe', '#70febc', '#72febb', '#74feba', '#76ffb9', '#78ffb8', '#7affb7', '#7dffb6', '#7effb5', '#80ffb4', '#82ffb3', '#84ffb2', '#86ffb0', '#88ffaf', '#8bfeae', '#8cfead', '#8efeac', '#90feab', '#92fda9', '#94fda8', '#96fca7', '#99fca6', '#9bfba5', '#9cfba4', '#9efaa2', '#a0faa1', '#a2f9a0', '#a4f89f', '#a6f89d', '#a8f79c', '#abf69b', '#acf59a', '#aef498', '#b0f397', '#b2f396', '#b4f295', '#b6f193', '#b9ef92', '#bbee91', '#bced8f', '#beec8e', '#c0eb8d', '#c2ea8c', '#c4e88a', '#c6e789', '#c8e688', '#cbe486', '#cce385', '#cee184', '#d0e082', '#d2de81', '#d4dd80', '#d6db7e', '#d9da7d', '#dbd87b', '#dcd67a', '#ded579', '#e0d377', '#e2d176', '#e4cf74', '#e6cd73', '#e8cb72', '#ebca70', '#ecc86f', '#eec66d', '#f0c46c', '#f2c26b', '#f4c069', '#f6be68', '#f9bb66', '#fbb965', '#fcb763', '#feb562', '#ffb360', '#ffb05f', '#ffae5e', '#ffac5c', '#ffa95b', '#ffa759', '#ffa558', '#ffa256', '#ffa055', '#ff9d53', '#ff9b52', '#ff9850', '#ff964f', '#ff934d', '#ff914c', '#ff8e4a', '#ff8c49', '#ff8947', '#ff8646', '#ff8444', '#ff8143', '#ff7e41', '#ff7b40', '#ff793e', '#ff763d', '#ff733b', '#ff703a', '#ff6d38', '#ff6b37', '#ff6835', '#ff6533', '#ff6232', '#ff5f30', '#ff5c2f', '#ff592d', '#ff562c', '#ff532a', '#ff5029', '#ff4d27', '#ff4a26', '#ff4724', '#ff4422', '#ff4121', '#ff3e1f', '#ff3b1e', '#ff381c', '#ff351b', '#ff3219', '#ff2f18', '#ff2c16', '#ff2914', '#ff2613', '#ff2211', '#ff1f10', '#ff1c0e', '#ff190d', '#ff160b', '#ff1309', '#ff1008', '#ff0d06', '#ff0905', '#ff0603', '#ff0302', '#ff0000']);
    var color_scale_gist_rainbow = chroma.scale(['#ff0029', '#ff0023', '#ff001e', '#ff0019', '#ff0013', '#ff000e', '#ff0009', '#ff0003', '#ff0200', '#ff0700', '#ff0d00', '#ff1200', '#ff1800', '#ff1d00', '#ff2200', '#ff2800', '#ff2d00', '#ff3300', '#ff3800', '#ff3d00', '#ff4300', '#ff4800', '#ff4e00', '#ff5300', '#ff5800', '#ff5e00', '#ff6300', '#ff6900', '#ff6e00', '#ff7300', '#ff7900', '#ff7e00', '#ff8400', '#ff8900', '#ff8e00', '#ff9400', '#ff9900', '#ff9f00', '#ffa400', '#ffa900', '#ffaf00', '#ffb400', '#ffba00', '#ffbf00', '#ffc400', '#ffca00', '#ffcf00', '#ffd500', '#ffda00', '#ffe000', '#ffe500', '#ffea00', '#fff000', '#fff500', '#fffb00', '#feff00', '#f9ff00', '#f3ff00', '#eeff00', '#e8ff00', '#e3ff00', '#deff00', '#d8ff00', '#d3ff00', '#cdff00', '#c8ff00', '#c3ff00', '#bdff00', '#b8ff00', '#b2ff00', '#adff00', '#a8ff00', '#a2ff00', '#9dff00', '#97ff00', '#92ff00', '#8dff00', '#87ff00', '#82ff00', '#7cff00', '#77ff00', '#72ff00', '#6cff00', '#67ff00', '#61ff00', '#5cff00', '#56ff00', '#51ff00', '#4cff00', '#46ff00', '#41ff00', '#3bff00', '#36ff00', '#31ff00', '#2bff00', '#26ff00', '#20ff00', '#1bff00', '#16ff00', '#10ff00', '#0bff00', '#05ff00', '#00ff00', '#00ff05', '#00ff0b', '#00ff10', '#00ff16', '#00ff1b', '#00ff20', '#00ff26', '#00ff2b', '#00ff30', '#00ff36', '#00ff3b', '#00ff41', '#00ff46', '#00ff4b', '#00ff51', '#00ff56', '#00ff5b', '#00ff61', '#00ff66', '#00ff6c', '#00ff71', '#00ff76', '#00ff7c', '#00ff81', '#00ff86', '#00ff8c', '#00ff91', '#00ff97', '#00ff9c', '#00ffa1', '#00ffa7', '#00ffac', '#00ffb1', '#00ffb7', '#00ffbc', '#00ffc2', '#00ffc7', '#00ffcc', '#00ffd2', '#00ffd7', '#00ffdc', '#00ffe2', '#00ffe7', '#00ffed', '#00fff2', '#00fff7', '#00fffd', '#00fcff', '#00f6ff', '#00f1ff', '#00ecff', '#00e6ff', '#00e1ff', '#00dbff', '#00d6ff', '#00d0ff', '#00cbff', '#00c6ff', '#00c0ff', '#00bbff', '#00b5ff', '#00b0ff', '#00aaff', '#00a5ff', '#00a0ff', '#009aff', '#0095ff', '#008fff', '#008aff', '#0084ff', '#007fff', '#0079ff', '#0074ff', '#006fff', '#0069ff', '#0064ff', '#005eff', '#0059ff', '#0053ff', '#004eff', '#0049ff', '#0043ff', '#003eff', '#0038ff', '#0033ff', '#002dff', '#0028ff', '#0023ff', '#001dff', '#0018ff', '#0012ff', '#000dff', '#0007ff', '#0002ff', '#0400ff', '#0900ff', '#0e00ff', '#1400ff', '#1900ff', '#1f00ff', '#2400ff', '#2a00ff', '#2f00ff', '#3400ff', '#3a00ff', '#3f00ff', '#4500ff', '#4a00ff', '#5000ff', '#5500ff', '#5a00ff', '#6000ff', '#6500ff', '#6b00ff', '#7000ff', '#7600ff', '#7b00ff', '#8100ff', '#8600ff', '#8b00ff', '#9100ff', '#9600ff', '#9c00ff', '#a100ff', '#a700ff', '#ac00ff', '#b100ff', '#b700ff', '#bc00ff', '#c200ff', '#c700ff', '#cd00ff', '#d200ff', '#d700ff', '#dd00ff', '#e200ff', '#e800ff', '#ed00ff', '#f300ff', '#f800ff', '#fe00ff', '#ff00fb', '#ff00f6', '#ff00f0', '#ff00eb', '#ff00e5', '#ff00e0', '#ff00da', '#ff00d5', '#ff00d0', '#ff00ca', '#ff00c5', '#ff00bf']);
    var color_scale_hot = chroma.scale(['#0b0000', '#0d0000', '#100000', '#120000', '#150000', '#180000', '#1a0000', '#1d0000', '#200000', '#220000', '#250000', '#270000', '#2a0000', '#2d0000', '#2f0000', '#320000', '#350000', '#370000', '#3a0000', '#3c0000', '#3f0000', '#420000', '#440000', '#470000', '#4a0000', '#4c0000', '#4f0000', '#510000', '#540000', '#570000', '#590000', '#5c0000', '#5f0000', '#610000', '#640000', '#660000', '#690000', '#6c0000', '#6e0000', '#710000', '#740000', '#760000', '#790000', '#7b0000', '#7e0000', '#810000', '#830000', '#860000', '#890000', '#8b0000', '#8e0000', '#900000', '#930000', '#960000', '#980000', '#9b0000', '#9e0000', '#a00000', '#a30000', '#a50000', '#a80000', '#ab0000', '#ad0000', '#b00000', '#b30000', '#b50000', '#b80000', '#ba0000', '#bd0000', '#c00000', '#c20000', '#c50000', '#c80000', '#ca0000', '#cd0000', '#cf0000', '#d20000', '#d50000', '#d70000', '#da0000', '#dd0000', '#df0000', '#e20000', '#e40000', '#e70000', '#ea0000', '#ec0000', '#ef0000', '#f20000', '#f40000', '#f70000', '#f90000', '#fc0000', '#ff0000', '#ff0200', '#ff0500', '#ff0800', '#ff0a00', '#ff0d00', '#ff1000', '#ff1200', '#ff1500', '#ff1700', '#ff1a00', '#ff1d00', '#ff1f00', '#ff2200', '#ff2500', '#ff2700', '#ff2a00', '#ff2c00', '#ff2f00', '#ff3200', '#ff3400', '#ff3700', '#ff3a00', '#ff3c00', '#ff3f00', '#ff4100', '#ff4400', '#ff4700', '#ff4900', '#ff4c00', '#ff4f00', '#ff5100', '#ff5400', '#ff5600', '#ff5900', '#ff5c00', '#ff5e00', '#ff6100', '#ff6400', '#ff6600', '#ff6900', '#ff6b00', '#ff6e00', '#ff7100', '#ff7300', '#ff7600', '#ff7900', '#ff7b00', '#ff7e00', '#ff8000', '#ff8300', '#ff8600', '#ff8800', '#ff8b00', '#ff8e00', '#ff9000', '#ff9300', '#ff9500', '#ff9800', '#ff9b00', '#ff9d00', '#ffa000', '#ffa200', '#ffa500', '#ffa800', '#ffaa00', '#ffad00', '#ffb000', '#ffb200', '#ffb500', '#ffb700', '#ffba00', '#ffbd00', '#ffbf00', '#ffc200', '#ffc500', '#ffc700', '#ffca00', '#ffcc00', '#ffcf00', '#ffd200', '#ffd400', '#ffd700', '#ffda00', '#ffdc00', '#ffdf00', '#ffe100', '#ffe400', '#ffe700', '#ffe900', '#ffec00', '#ffef00', '#fff100', '#fff400', '#fff600', '#fff900', '#fffc00', '#fffe00', '#ffff03', '#ffff07', '#ffff0b', '#ffff0f', '#ffff13', '#ffff17', '#ffff1b', '#ffff1f', '#ffff22', '#ffff26', '#ffff2a', '#ffff2e', '#ffff32', '#ffff36', '#ffff3a', '#ffff3e', '#ffff42', '#ffff46', '#ffff4a', '#ffff4e', '#ffff52', '#ffff56', '#ffff5a', '#ffff5e', '#ffff61', '#ffff65', '#ffff69', '#ffff6d', '#ffff71', '#ffff75', '#ffff79', '#ffff7d', '#ffff81', '#ffff85', '#ffff89', '#ffff8d', '#ffff91', '#ffff95', '#ffff99', '#ffff9d', '#ffffa0', '#ffffa4', '#ffffa8', '#ffffac', '#ffffb0', '#ffffb4', '#ffffb8', '#ffffbc', '#ffffc0', '#ffffc4', '#ffffc8', '#ffffcc', '#ffffd0', '#ffffd4', '#ffffd8', '#ffffdc', '#ffffdf', '#ffffe3', '#ffffe7', '#ffffeb', '#ffffef', '#fffff3', '#fffff7', '#fffffb', '#ffffff']);
    var color_scale_brg = chroma.scale(['#0000ff', '#0200fd', '#0400fb', '#0600f9', '#0800f7', '#0a00f5', '#0c00f3', '#0e00f1', '#1000ef', '#1200ed', '#1400eb', '#1600e9', '#1800e7', '#1a00e5', '#1c00e3', '#1e00e1', '#2000df', '#2200dd', '#2400db', '#2600d9', '#2800d7', '#2a00d5', '#2c00d3', '#2e00d1', '#3000cf', '#3200cd', '#3400cb', '#3600c9', '#3800c7', '#3a00c5', '#3c00c3', '#3e00c1', '#4000bf', '#4200bd', '#4400bb', '#4600b9', '#4800b7', '#4a00b5', '#4c00b3', '#4e00b1', '#5000af', '#5200ad', '#5400ab', '#5600a9', '#5800a7', '#5a00a5', '#5c00a3', '#5e00a1', '#60009f', '#62009d', '#64009b', '#660099', '#680097', '#6a0095', '#6c0093', '#6e0091', '#70008f', '#72008d', '#74008b', '#760089', '#780087', '#7a0085', '#7c0083', '#7e0081', '#80007f', '#82007d', '#84007b', '#860079', '#880077', '#8a0075', '#8c0073', '#8e0071', '#90006f', '#92006d', '#94006b', '#960069', '#980067', '#9a0065', '#9c0063', '#9e0061', '#a0005f', '#a2005d', '#a4005b', '#a60059', '#a80057', '#aa0055', '#ac0053', '#ae0051', '#b0004f', '#b2004d', '#b4004b', '#b60049', '#b80047', '#ba0045', '#bc0043', '#be0041', '#c0003f', '#c2003d', '#c4003b', '#c60039', '#c80037', '#ca0035', '#cc0033', '#ce0031', '#d0002f', '#d2002d', '#d4002b', '#d60029', '#d80027', '#da0025', '#dc0023', '#de0021', '#e0001f', '#e2001d', '#e4001b', '#e60019', '#e80017', '#ea0015', '#ec0013', '#ee0011', '#f0000f', '#f2000d', '#f4000b', '#f60009', '#f80007', '#fa0005', '#fc0003', '#fe0001', '#fe0100', '#fc0300', '#fa0500', '#f80700', '#f60900', '#f40b00', '#f20d00', '#f00f00', '#ee1100', '#ec1300', '#ea1500', '#e81700', '#e61900', '#e41b00', '#e21d00', '#e01f00', '#de2100', '#dc2300', '#da2500', '#d82700', '#d62900', '#d42b00', '#d22d00', '#d02f00', '#ce3100', '#cc3300', '#ca3500', '#c83700', '#c63900', '#c43b00', '#c23d00', '#c03f00', '#be4100', '#bc4300', '#ba4500', '#b84700', '#b64900', '#b44b00', '#b24d00', '#b04f00', '#ae5100', '#ac5300', '#aa5500', '#a85700', '#a65900', '#a45b00', '#a25d00', '#a05f00', '#9e6100', '#9c6300', '#9a6500', '#986700', '#966900', '#946b00', '#926d00', '#906f00', '#8e7100', '#8c7300', '#8a7500', '#887700', '#867900', '#847b00', '#827d00', '#807f00', '#7e8100', '#7c8300', '#7a8500', '#788700', '#768900', '#748b00', '#728d00', '#708f00', '#6e9100', '#6c9300', '#6a9500', '#689700', '#669900', '#649b00', '#629d00', '#609f00', '#5ea100', '#5ca300', '#5aa500', '#58a700', '#56a900', '#54ab00', '#52ad00', '#50af00', '#4eb100', '#4cb300', '#4ab500', '#48b700', '#46b900', '#44bb00', '#42bd00', '#40bf00', '#3ec100', '#3cc300', '#3ac500', '#38c700', '#36c900', '#34cb00', '#32cd00', '#30cf00', '#2ed100', '#2cd300', '#2ad500', '#28d700', '#26d900', '#24db00', '#22dd00', '#20df00', '#1ee100', '#1ce300', '#1ae500', '#18e700', '#16e900', '#14eb00', '#12ed00', '#10ef00', '#0ef100', '#0cf300', '#0af500', '#08f700', '#06f900', '#04fb00', '#02fd00', '#00ff00']);
    var color_scale_seismic = chroma.scale(['#00004c', '#00004f', '#000052', '#000055', '#000058', '#00005a', '#00005d', '#000060', '#000063', '#000066', '#000068', '#00006b', '#00006e', '#000071', '#000074', '#000076', '#000079', '#00007c', '#00007f', '#000082', '#000084', '#000087', '#00008a', '#00008d', '#000090', '#000092', '#000095', '#000098', '#00009b', '#00009e', '#0000a0', '#0000a3', '#0000a6', '#0000a9', '#0000ac', '#0000ae', '#0000b1', '#0000b4', '#0000b7', '#0000ba', '#0000bc', '#0000bf', '#0000c2', '#0000c5', '#0000c8', '#0000ca', '#0000cd', '#0000d0', '#0000d3', '#0000d6', '#0000d8', '#0000db', '#0000de', '#0000e1', '#0000e4', '#0000e6', '#0000e9', '#0000ec', '#0000ef', '#0000f2', '#0000f4', '#0000f7', '#0000fa', '#0000fd', '#0101ff', '#0505ff', '#0909ff', '#0d0dff', '#1111ff', '#1515ff', '#1919ff', '#1d1dff', '#2121ff', '#2525ff', '#2929ff', '#2d2dff', '#3131ff', '#3535ff', '#3939ff', '#3d3dff', '#4141ff', '#4545ff', '#4949ff', '#4d4dff', '#5151ff', '#5555ff', '#5959ff', '#5d5dff', '#6161ff', '#6565ff', '#6969ff', '#6d6dff', '#7171ff', '#7575ff', '#7979ff', '#7d7dff', '#8181ff', '#8585ff', '#8989ff', '#8d8dff', '#9191ff', '#9595ff', '#9999ff', '#9d9dff', '#a1a1ff', '#a5a5ff', '#a9a9ff', '#adadff', '#b1b1ff', '#b5b5ff', '#b9b9ff', '#bdbdff', '#c1c1ff', '#c5c5ff', '#c9c9ff', '#cdcdff', '#d1d1ff', '#d5d5ff', '#d9d9ff', '#ddddff', '#e1e1ff', '#e5e5ff', '#e9e9ff', '#ededff', '#f1f1ff', '#f5f5ff', '#f9f9ff', '#fdfdff', '#fffdfd', '#fff9f9', '#fff5f5', '#fff1f1', '#ffeded', '#ffe9e9', '#ffe5e5', '#ffe1e1', '#ffdddd', '#ffd9d9', '#ffd5d5', '#ffd1d1', '#ffcdcd', '#ffc9c9', '#ffc5c5', '#ffc1c1', '#ffbdbd', '#ffb9b9', '#ffb5b5', '#ffb1b1', '#ffadad', '#ffa9a9', '#ffa5a5', '#ffa1a1', '#ff9d9d', '#ff9999', '#ff9595', '#ff9191', '#ff8d8d', '#ff8989', '#ff8585', '#ff8181', '#ff7d7d', '#ff7979', '#ff7575', '#ff7171', '#ff6d6d', '#ff6969', '#ff6565', '#ff6161', '#ff5d5d', '#ff5959', '#ff5555', '#ff5151', '#ff4d4d', '#ff4949', '#ff4545', '#ff4141', '#ff3d3d', '#ff3939', '#ff3535', '#ff3131', '#ff2d2d', '#ff2929', '#ff2525', '#ff2121', '#ff1d1d', '#ff1919', '#ff1515', '#ff1111', '#ff0d0d', '#ff0909', '#ff0505', '#ff0101', '#fe0000', '#fc0000', '#fa0000', '#f80000', '#f60000', '#f40000', '#f20000', '#f00000', '#ee0000', '#ec0000', '#ea0000', '#e80000', '#e60000', '#e30000', '#e20000', '#e00000', '#de0000', '#dc0000', '#da0000', '#d80000', '#d60000', '#d30000', '#d20000', '#d00000', '#ce0000', '#cc0000', '#ca0000', '#c80000', '#c60000', '#c30000', '#c20000', '#c00000', '#be0000', '#bc0000', '#ba0000', '#b80000', '#b60000', '#b30000', '#b20000', '#b00000', '#ae0000', '#ac0000', '#aa0000', '#a80000', '#a60000', '#a30000', '#a20000', '#a00000', '#9e0000', '#9c0000', '#9a0000', '#980000', '#960000', '#930000', '#920000', '#900000', '#8e0000', '#8c0000', '#8a0000', '#880000', '#860000', '#840000', '#820000', '#800000']);
    //var color_scale_binary = chroma.scale(['#ffffff', '#fefefe', '#fdfdfd', '#fcfcfc', '#fbfbfb', '#fafafa', '#f9f9f9', '#f8f8f8', '#f7f7f7', '#f6f6f6', '#f5f5f5', '#f4f4f4', '#f3f3f3', '#f2f2f2', '#f1f1f1', '#f0f0f0', '#efefef', '#eeeeee', '#ededed', '#ececec', '#ebebeb', '#eaeaea', '#e9e9e9', '#e8e8e8', '#e7e7e7', '#e6e6e6', '#e5e5e5', '#e4e4e4', '#e3e3e3', '#e2e2e2', '#e1e1e1', '#e0e0e0', '#dfdfdf', '#dedede', '#dddddd', '#dcdcdc', '#dbdbdb', '#dadada', '#d9d9d9', '#d8d8d8', '#d7d7d7', '#d6d6d6', '#d5d5d5', '#d4d4d4', '#d3d3d3', '#d2d2d2', '#d1d1d1', '#d0d0d0', '#cfcfcf', '#cecece', '#cdcdcd', '#cccccc', '#cbcbcb', '#cacaca', '#c9c9c9', '#c8c8c8', '#c7c7c7', '#c6c6c6', '#c5c5c5', '#c4c4c4', '#c3c3c3', '#c2c2c2', '#c1c1c1', '#c0c0c0', '#bfbfbf', '#bebebe', '#bdbdbd', '#bcbcbc', '#bbbbbb', '#bababa', '#b9b9b9', '#b8b8b8', '#b7b7b7', '#b6b6b6', '#b5b5b5', '#b4b4b4', '#b3b3b3', '#b2b2b2', '#b1b1b1', '#b0b0b0', '#afafaf', '#aeaeae', '#adadad', '#acacac', '#ababab', '#aaaaaa', '#a9a9a9', '#a8a8a8', '#a7a7a7', '#a6a6a6', '#a5a5a5', '#a4a4a4', '#a3a3a3', '#a2a2a2', '#a1a1a1', '#a0a0a0', '#9f9f9f', '#9e9e9e', '#9d9d9d', '#9c9c9c', '#9b9b9b', '#9a9a9a', '#999999', '#989898', '#979797', '#969696', '#959595', '#949494', '#939393', '#929292', '#919191', '#909090', '#8f8f8f', '#8e8e8e', '#8d8d8d', '#8c8c8c', '#8b8b8b', '#8a8a8a', '#898989', '#888888', '#878787', '#868686', '#858585', '#848484', '#838383', '#828282', '#818181', '#808080', '#7f7f7f', '#7e7e7e', '#7d7d7d', '#7c7c7c', '#7b7b7b', '#7a7a7a', '#797979', '#787878', '#777777', '#767676', '#757575', '#747474', '#737373', '#727272', '#717171', '#707070', '#6f6f6f', '#6e6e6e', '#6d6d6d', '#6c6c6c', '#6b6b6b', '#6a6a6a', '#696969', '#686868', '#676767', '#666666', '#656565', '#646464', '#636363', '#626262', '#616161', '#606060', '#5f5f5f', '#5e5e5e', '#5d5d5d', '#5c5c5c', '#5b5b5b', '#5a5a5a', '#595959', '#585858', '#575757', '#565656', '#555555', '#545454', '#535353', '#525252', '#515151', '#505050', '#4f4f4f', '#4e4e4e', '#4d4d4d', '#4c4c4c', '#4b4b4b', '#4a4a4a', '#494949', '#484848', '#474747', '#464646', '#454545', '#444444', '#434343', '#424242', '#414141', '#404040', '#3f3f3f', '#3e3e3e', '#3d3d3d', '#3c3c3c', '#3b3b3b', '#3a3a3a', '#393939', '#383838', '#373737', '#363636', '#353535', '#343434', '#333333', '#323232', '#313131', '#303030', '#2f2f2f', '#2e2e2e', '#2d2d2d', '#2c2c2c', '#2b2b2b', '#2a2a2a', '#292929', '#282828', '#272727', '#262626', '#252525', '#242424', '#232323', '#222222', '#212121', '#202020', '#1f1f1f', '#1e1e1e', '#1d1d1d', '#1c1c1c', '#1b1b1b', '#1a1a1a', '#191919', '#181818', '#171717', '#161616', '#151515', '#141414', '#131313', '#121212', '#111111', '#101010', '#0f0f0f', '#0e0e0e', '#0d0d0d', '#0c0c0c', '#0b0b0b', '#0a0a0a', '#090909', '#080808', '#070707', '#060606', '#050505', '#040404', '#030303', '#020202', '#010101', '#000000']);
    var color_scale_binary = chroma.scale(['#ffffff', '#ffffff', '#fefefe', '#fefefe', '#fdfdfd', '#fdfdfd', '#fcfcfc', '#fcfcfc', '#fbfbfb', '#fbfbfb', '#fafafa', '#fafafa', '#f9f9f9', '#f9f9f9', '#f8f8f8', '#f8f8f8', '#f7f7f7', '#f7f7f7', '#f7f7f7', '#f6f6f6', '#f6f6f6', '#f5f5f5', '#f5f5f5', '#f4f4f4', '#f4f4f4', '#f3f3f3', '#f3f3f3', '#f2f2f2', '#f2f2f2', '#f1f1f1', '#f1f1f1', '#f0f0f0', '#f0f0f0', '#efefef', '#eeeeee', '#eeeeee', '#ededed', '#ececec', '#ececec', '#ebebeb', '#eaeaea', '#e9e9e9', '#e9e9e9', '#e8e8e8', '#e7e7e7', '#e7e7e7', '#e6e6e6', '#e5e5e5', '#e4e4e4', '#e4e4e4', '#e3e3e3', '#e2e2e2', '#e1e1e1', '#e1e1e1', '#e0e0e0', '#dfdfdf', '#dfdfdf', '#dedede', '#dddddd', '#dcdcdc', '#dcdcdc', '#dbdbdb', '#dadada', '#dadada', '#d9d9d9', '#d8d8d8', '#d7d7d7', '#d6d6d6', '#d5d5d5', '#d4d4d4', '#d4d4d4', '#d3d3d3', '#d2d2d2', '#d1d1d1', '#d0d0d0', '#cfcfcf', '#cecece', '#cdcdcd', '#cccccc', '#cccccc', '#cbcbcb', '#cacaca', '#c9c9c9', '#c8c8c8', '#c7c7c7', '#c6c6c6', '#c5c5c5', '#c5c5c5', '#c4c4c4', '#c3c3c3', '#c2c2c2', '#c1c1c1', '#c0c0c0', '#bfbfbf', '#bebebe', '#bebebe', '#bdbdbd', '#bbbbbb', '#bababa', '#b9b9b9', '#b8b8b8', '#b6b6b6', '#b5b5b5', '#b4b4b4', '#b3b3b3', '#b2b2b2', '#b0b0b0', '#afafaf', '#aeaeae', '#adadad', '#ababab', '#aaaaaa', '#a9a9a9', '#a8a8a8', '#a7a7a7', '#a5a5a5', '#a4a4a4', '#a3a3a3', '#a2a2a2', '#a0a0a0', '#9f9f9f', '#9e9e9e', '#9d9d9d', '#9c9c9c', '#9a9a9a', '#999999', '#989898', '#979797', '#959595', '#949494', '#939393', '#929292', '#919191', '#909090', '#8f8f8f', '#8e8e8e', '#8d8d8d', '#8c8c8c', '#8a8a8a', '#898989', '#888888', '#878787', '#868686', '#858585', '#848484', '#838383', '#828282', '#818181', '#7f7f7f', '#7e7e7e', '#7d7d7d', '#7c7c7c', '#7b7b7b', '#7a7a7a', '#797979', '#787878', '#777777', '#767676', '#757575', '#737373', '#727272', '#717171', '#707070', '#6f6f6f', '#6e6e6e', '#6d6d6d', '#6c6c6c', '#6b6b6b', '#6a6a6a', '#696969', '#686868', '#676767', '#666666', '#656565', '#646464', '#636363', '#626262', '#616161', '#606060', '#5f5f5f', '#5e5e5e', '#5d5d5d', '#5c5c5c', '#5b5b5b', '#5a5a5a', '#585858', '#575757', '#565656', '#555555', '#545454', '#535353', '#525252', '#515151', '#505050', '#4e4e4e', '#4d4d4d', '#4b4b4b', '#4a4a4a', '#484848', '#474747', '#464646', '#444444', '#434343', '#414141', '#404040', '#3f3f3f', '#3d3d3d', '#3c3c3c', '#3a3a3a', '#393939', '#383838', '#363636', '#353535', '#333333', '#323232', '#303030', '#2f2f2f', '#2e2e2e', '#2c2c2c', '#2b2b2b', '#292929', '#282828', '#272727', '#252525', '#242424', '#232323', '#222222', '#212121', '#1f1f1f', '#1e1e1e', '#1d1d1d', '#1c1c1c', '#1b1b1b', '#1a1a1a', '#181818', '#171717', '#161616', '#151515', '#141414', '#131313', '#111111', '#101010', '#0f0f0f', '#0e0e0e', '#0d0d0d', '#0c0c0c', '#0a0a0a', '#090909', '#080808', '#070707', '#060606', '#050505', '#030303', '#020202', '#010101', '#000000']);
    var color_scale_cyan_light_to_blue_dark = chroma.scale([/*'#00FFFF'*//*'#a5ffff'*/'#00f1f5','#443dff', /*'#00008B'*/'#000060']);
    

    function calcularFracoes(min, max) {
        // Verifica se min é menor que max
        if (min >= max) {
            throw new Error("O valor mínimo deve ser menor que o valor máximo.");
        }

        // Calcula os valores correspondentes
        const valor25 = min + (max - min) * 0.25;
        const valor50 = min + (max - min) * 0.50;
        const valor75 = min + (max - min) * 0.75;

        // Retorna os valores como um objeto
        return {
            "min": {"valor": min},
            "q1":  {"valor": valor25},
            "q2":  {"valor": valor50},
            "q3":  {"valor": valor75},
            "max": {"valor": max},
        };
    }

    function preparaColorMap() {
        //var color_scale = chroma.scale(['#00f', '#0f0', '#ffff00', '#ff0000']).mode('hsl');
        //console.log(data_colormap);
        if (map.current === null || data_colormap.current == [] || data_colormap.current == null || data_colormap.current == undefined)
            return;        

        if (typeof mapa_cor_value != "undefined" && mapa_cor_value != null) {
            if (mapa_cor_value == "jet") {
                color_scale = color_scale_jet;
            } else if (mapa_cor_value == "gray") {
                color_scale = color_scale_gray;
            } else if (mapa_cor_value == "rainbow") {
                color_scale = color_scale_rainbow;
            } else if (mapa_cor_value == "gist_rainbow") {
                color_scale = color_scale_gist_rainbow;
            } else if (mapa_cor_value == "hot") {
                color_scale = color_scale_hot;
            } else if (mapa_cor_value == "brg") {
                color_scale = color_scale_brg;
            } else if (mapa_cor_value  == "seismic") {
                color_scale = color_scale_seismic;
            } else if (mapa_cor_value == "binary") {
                color_scale = color_scale_binary;
            } else if (mapa_cor_value == "cyan_light_to_blue_dark") {
                color_scale = color_scale_cyan_light_to_blue_dark;
            }
        }

        const generateColors = (colorPalette) => {
            if (legend.current !== null) {
                map.current.removeControl(legend.current );
                legend.current  = null;
            }
            legend.current  = L.control({ position: "bottomleft" });

            legend.current.onAdd = function (map) {
                var div = null;
                div = L.DomUtil.create("div", "legend_");

                div.innerHTML += "<div>";


                // Adicionando linhas para cada cor e descrição 
                var descricaoIndice = "";
                if(indice.toLowerCase() === "mmaing"){
                    descricaoIndice = t("dashboard.table.ml");
                } else if(indice.toLowerCase() === "ens"){
                    descricaoIndice = t("dashboard.table.ens");
                } else if(indice.toLowerCase() === "evi") {
                    descricaoIndice = t("dashboard.evi_simples");
                } else if(indice.toLowerCase() === "glm") {
                    descricaoIndice = t("dashboard.table.glm");
                } else {
                    descricaoIndice = t("dashboard.ears");
                }

                let corNaoApto = theme === "dark" ? corMapaNaoAptoDark : corMapaNaoApto;
                let corNoData = theme === "dark" ? corMapaNoData : corMapaNoData;

                if(checkedAvisos){
                    div.innerHTML += '<center><h6 class="titulo-legend">' + descricaoIndice + '</h6></center>';
                    div.innerHTML += '<div class="legend-item"><img style="max-width:25px; max-heigth:25px; margin-right: 5px;" src="'+iconVermelhoUrl+'" />'+t("dashboard.aviso") + '</div>';
                    div.innerHTML += '<div class="legend-item"><img style="max-width:25px; max-heigth:25px; margin-right: 5px;" src="'+iconAmareloUrl+'" />'+t("dashboard.alerta")+'</div>';
                    div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: '+ corNaoApto +'; margin-left: 5px; margin-right: 10px;"></div>'+t("dashboard.nao_apto")+'</div>';

                    div.innerHTML += '</div>';
                }

                /*let corNaoApto = theme === "dark" ? corMapaNaoAptoDark : corMapaNaoApto;
                let corNoData = theme === "dark" ? corMapaNoDataDark : corMapaNoData;

                let descricaoIndice = "escala " + escala;

                div.innerHTML += '<center><h6 class="titulo-legend">' + descricaoIndice + '</h6></center>';
                div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: '+corMapa3+'"></div>'+t("dashboard.aviso") + '</div>';
                div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: lightcoral;"></div>'+t("dashboard.aviso_consecutivo")+'</div>';
                div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: '+corMapa2+'"></div>'+t("dashboard.alerta")+'</div>';
                div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: '+corMapa1+'"></div>'+t("dashboard.sem_aviso")+'</div>';
                div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: '+ corNaoApto +'"></div>'+t("dashboard.nao_apto")+'</div>';
                div.innerHTML += '<div class="legend-item"><div class="square" style="background-color: '+ corNoData +'"></div>'+t("dashboard.no_data")+'</div>';

                div.innerHTML += '</div>';            */

                let colorContainer = div;
                //colorContainer.style.display = "none";


                let trTitulos = "<tr>";
                let trValores = "<tr>";
                function colorArrayElements(color, index, array) {
                    var valMin = 0;
                    var valMax = 0;
                    var valQ1 = 0;
                    var valQ2 = 0;
                    var valQ3 = 0;

                    valMin = parseFloat(data_colormap.current['min']['valor']).toFixed(1);
                    valMax = parseFloat(data_colormap.current['max']['valor']).toFixed(1);

                    valQ1 = parseFloat(data_colormap.current['q1']['valor']).toFixed(1);
                    valQ2 = parseFloat(data_colormap.current['q2']['valor']).toFixed(1);
                    valQ3 = parseFloat(data_colormap.current['q3']['valor']).toFixed(1);

                    let fator = 1;

                    let maior_valor_stream = Number(valMax) * fator;
                    maior_valor_stream = maior_valor_stream + (maior_valor_stream * 0.05);
                    let menor_valor_stream = Number(valMin) * fator;

                    let stringTitulo = "";

                    switch (index) {
                        case array.length - 1:
                            stringTitulo = '  ' + valMax;
                            break;
                        case 0:
                            stringTitulo = '  ' + valMin;
                            break;
                        case 3:
                            stringTitulo = '  ' + valQ3;
                            break;
                        case 2:
                            stringTitulo = '  ' + valQ2;
                            break;
                        case 1:
                            stringTitulo = '  ' + valQ1;
                            break;
                    }

                    let td = "<td  style=\"min-width: 55px; text-align: center; padding-right: 5px; padding-left: 5; background: "+color+"; background: linear-gradient(90deg, " + array[index] + ", " + array[index + 1] + ");\" >&nbsp</td>";
                    let tdTitulo = "<td style=\"min-width: 55px; text-align: center; padding-right: 5px; padding-left: 5\">" + stringTitulo + "</td>";
                    trTitulos += " " + tdTitulo;
                    trValores += " " + td;                    
                }

                let paletaTemporariaCores = colorPalette.colors(5); //.reverse();
                paletaTemporariaCores.forEach(colorArrayElements);
                trTitulos += "</tr>";
                trValores += "</tr>";


                for(let i = 0; i < tipoEscala.length; i++){
                    if(tipoEscala[i].nome === variavel){
                        escala = tipoEscala[i].tipo;
                        break;
                    }
                }

                let descricaoVariavel = "";
                //percorra as listaVariaveisClima e pegue a descrição da variável
                for(let i = 0; i < listaVariaveisClima.length; i++){
                    if(listaVariaveisClima[i].value === variavel){
                        descricaoVariavel = listaVariaveisClima[i].nome;
                        break;
                    }
                }

                div.innerHTML += "<center><div><h6 class=\"titulo-legend\">" + descricaoVariavel/*t("dashboard.legenda")*/ +" "+ escala + "</h6></div></center>";
                div.innerHTML += "<table class=\"tableEscala\">" + trTitulos + trValores + "</table>";
                return div;
            };
            
            legend.current.addTo(map.current); 
        };

        generateColors(color_scale);       
    }

    function getColorMap(e) {
        var colormap = color_scale_binary;
        if (e == "jet") {
            colormap = color_scale_jet;
        } else if (e == "gray") {
            colormap = color_scale_gray;
        } else if (e == "rainbow") {
            colormap = color_scale_rainbow;
        } else if (e == "gist_rainbow") {
            colormap = color_scale_gist_rainbow;
        } else if (e == "hot") {
            colormap = color_scale_hot;
        } else if (e == "brg") {
            colormap = color_scale_brg;
        } else if (e == "seismic") {
            colormap = color_scale_seismic;
        } else if (e == "binary") {
            colormap = color_scale_binary;
        } else if (e == "cyan_light_to_blue_dark") {
            colormap = color_scale_cyan_light_to_blue_dark;
        }
        return colormap;
    }

    useEffect(() => {
        if(!iniciou.current)
            return;
        
        var url = theme === "dark" ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

        const { innerWidth: width, innerHeight: height } = window;

        layerTile.current = L.tileLayer(url, {
            zoomControl: true,
            zoomSnap: zoomSnap_,
            zoomDelta: zoomSnap_,
            wheelPxPerZoomLevel: wheelPxPerZoomLevel_,
            defaultZoom: defaultZoom,
            maxZoom: 18,
            id: 'mapbox.streets'
        });

        if (map.current === null) {
            map.current = L.map("map", {
                minZoom: 4,
                maxZoom: 10,
                layers: [layerTile.current]
            });
            //shapeFileBrasilExcesso.current.addTo(map.current);
        } else {
            map.current.invalidateSize();
        }

        const defaultCenter = position;

        if(width < 1300)
            map.current.setView([-13.338793, -45.206666], defaultZoom);
        else 
            map.current.setView(defaultCenter, defaultZoom);

        /*if(shapeFileMunicipios.current === null){
            shapeFileMunicipios.current = L.tileLayer('');
        }

        shapeFileMunicipios.current.addTo(map.current);
        shapeFileBrasil.current.addTo(map.current);*/

        const lineCoordinates = [
            [-22.890090, -42.029405], // Latitude e longitude do ponto inicial
            [-12.924167, -38.440701],  // Latitude e longitude do ponto final
          ];

        const lineCoordinates2 = [
            [-23.62340166156419, -46.65858576087318], // Latitude e longitude do ponto inicial
            [-12.988999467983497, -38.50386516595166],  // Latitude e longitude do ponto final
          ];

        if (map.current) {
            // Adiciona um ouvinte de evento para o evento de zoomend
            const onZoomEnd = (event) => {
              // Obtém o nível de zoom atual
              const currentZoom = event.target.getZoom();

              if(theme === "dark"){
                if(currentZoom <=  5){
                    weightNormal = 0.5;
                }  else {
                    weightNormal = 1;
                }
              }
              //console.log(currentZoom);
      
            };
      
            // Adiciona o ouvinte de evento ao mapa para o evento de zoomend
            map.current.on('zoomend', onZoomEnd);
        } 

        if(markersLayer === null)
            setMarkersLayer(L.layerGroup().addTo(map.current)); // Criando uma layer para os marcadores e adicionando ao mapa

        /*let myGeoRaster = "Dados/geotif/Bio01_BR.tif";

        const parseGeoraster = require("georaster");

        var noDataValue = 0;  */      
        
    }, [map]);

    useEffect(() => {
        let myGeoRaster = "Dados/geotif/"+variavel+".tif";

        const parseGeoraster = require("georaster");

        var noDataValue = 0;
        if(!loading){
            setLoading(true);
        }

        fetch(myGeoRaster)
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => {
            parseGeoraster(arrayBuffer).then(georaster => {
            
                min.current = georaster.mins[0];
                max.current = georaster.maxs[0];

                data_colormap.current = calcularFracoes(min.current, max.current);
                preparaColorMap();

                range.current = georaster.ranges[0];
                noDataValue = georaster.noDataValues;

                geoRaster.current = georaster;

                var scale = getColorMap(mapa_cor_value);

                try {

                    layer_.current = new GeoRasterLayer({
                        georaster: georaster,
                        opacity: 0.7,
                        pixelValuesToColorFn: function(pixelValues) {
                            var pixelValue = pixelValues[0];

                            if (pixelValue === 0 || pixelValue === -3.3999999521443642e+38) return null;

                            var scaledPixelValue = (pixelValue - min.current) / range.current;

                            var color = scale(scaledPixelValue).hex();

                            return color;
                        },
                        resolution: 64 // optional parameter for adjusting display resolution
                    });

                    layer_.current.addTo(map.current);

                    //map.current.fitBounds(layer_.current.getBounds());
    
                    for(let i = 0; i < tipoEscala.length; i++){
                        if(tipoEscala[i].nome === variavel){
                            setMapa_Cor_Value(tipoEscala[i].colormap);
                            break;
                        }
                    }   
                } catch (error) {
                    console.error("Erro capturado #:", error);
                    debugger; // para pausar e inspecionar   
                }

                        // Carregar GeoRasterLayer     

                setLoading(false);
            });
        }).catch(err => {
            console.error("Erro capturado 2:", err);
            debugger; // para pausar e inspecionar
        });
    }, [variavel]);

    useEffect(() => {
        if ((map.current === null))
            return;

        if (layerTile.current !== null) {
            map.current.removeLayer(layerTile.current);
        }

        var url = theme === "dark" ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";

        const defaultCenter = position;

        layerTile.current = L.tileLayer(url, {
            zoomControl: true,
            zoomSnap: zoomSnap_,
            zoomDelta: zoomSnap_,
            wheelPxPerZoomLevel: wheelPxPerZoomLevel_,
            defaultZoom: defaultZoom,
            maxZoom: 18,
            id: 'mapbox.streets'
        });
        /*map.current.setView(defaultCenter, defaultZoom);*/
        layerTile.current.addTo(map.current);

        if(layer_.current !== null){
            if (layer_.current !== null) {
                map.current.removeLayer(layer_.current);
            }

            var scale = getColorMap(mapa_cor_value);
            layer_.current = new GeoRasterLayer({
                georaster: geoRaster.current,
                opacity: 0.7,
                pixelValuesToColorFn: function(pixelValues) {
                    var pixelValue = pixelValues[0];

                    if (pixelValue === 0 || pixelValue === -3.3999999521443642e+38) return null;

                    var scaledPixelValue = (pixelValue - min.current) / range.current;

                    var color = scale(scaledPixelValue).hex();

                    return color;
                },
                resolution: 64 // optional parameter for adjusting display resolution
            });

            // Carregar GeoRasterLayer
            layer_.current.addTo(map.current);

            map.current.fitBounds(layer_.current.getBounds());
            layer_.current.addTo(map.current);
        }

    },[theme]);

    const createIcon = (iconUrl) => {
        return L.icon({
          iconUrl: iconUrl,
          iconSize: [20, 20],
          iconAnchor: [10, 10],
        });
    };

    useEffect(() => {
        setListaVariaveisClima([
            {"value":"Bio01_BR", "nome": t("dashboard.variaveisClima.Bio01BR")},
            {"value":"Bio02_BR", "nome": t("dashboard.variaveisClima.Bio02BR")},
            {"value":"Bio03_BR", "nome": t("dashboard.variaveisClima.Bio03BR")},
            {"value":"Bio04_BR", "nome": t("dashboard.variaveisClima.Bio04BR")},
            {"value":"Bio05_BR", "nome": t("dashboard.variaveisClima.Bio05BR")},
            {"value":"Bio06_BR", "nome": t("dashboard.variaveisClima.Bio06BR")},
            {"value":"Bio07_BR", "nome": t("dashboard.variaveisClima.Bio07BR")},
            {"value":"Bio08_BR", "nome": t("dashboard.variaveisClima.Bio08BR")},
            {"value":"Bio09_BR", "nome": t("dashboard.variaveisClima.Bio09BR")},
            {"value":"Bio10_BR", "nome": t("dashboard.variaveisClima.Bio10BR")},
            {"value":"Bio11_BR", "nome": t("dashboard.variaveisClima.Bio11BR")},
            {"value":"Bio12_BR", "nome": t("dashboard.variaveisClima.Bio12BR")},
            {"value":"Bio13_BR", "nome": t("dashboard.variaveisClima.Bio13BR")},
            {"value":"Bio14_BR", "nome": t("dashboard.variaveisClima.Bio14BR")},
            {"value":"Bio15_BR", "nome": t("dashboard.variaveisClima.Bio15BR")},
            {"value":"Bio16_BR", "nome": t("dashboard.variaveisClima.Bio16BR")},
            {"value":"Bio17_BR", "nome": t("dashboard.variaveisClima.Bio17BR")},
            {"value":"Bio18_BR", "nome": t("dashboard.variaveisClima.Bio18BR")},
            {"value":"Bio19_BR", "nome": t("dashboard.variaveisClima.Bio19BR")},
        ]);

        if(max.current !== 0 && min.current !== 0){
            data_colormap.current = calcularFracoes(min.current, max.current);
            preparaColorMap();
        }
        if(isAllSelect(estadoSelecionado)){
            setEstadoSelecionado(t("dashboard.todos"));
        }

        estados_labels[0] = {label:t("dashboard.todos")};

        if(isAllSelect(filtroDQIMapa)){
            setFiltroDQIMapa(t("dashboard.ambos"));
        } else if(filtroDQIMapa.toLocaleLowerCase() === "validated" || filtroDQIMapa.toLocaleLowerCase() === "validado"){
            setFiltroDQIMapa(t("dashboard.apto"));
        } else if(filtroDQIMapa.toLocaleLowerCase() === "not validated" || filtroDQIMapa.toLocaleLowerCase() === "não validado"){
            setFiltroDQIMapa(t("dashboard.nao_apto"));
        }

        if(isAllSelect(municipioSelecionado)){
            setListaMunicipios(getCidades());
            setMunicipioSelecionado(t("dashboard.todos"));
            let cidades_labels_tmp = [{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}];
            setCidades_Labels(cidades_labels_tmp);
        }
    }, [language]);

    useEffect(() => {
        if(max.current !== 0 && min.current !== 0){
            data_colormap.current = calcularFracoes(min.current, max.current);
            preparaColorMap();
        }
    }, [listaVariaveisClima]);

    const addMarker = (coords, icon, element) => {
        if (markersLayer) {
            //console.log(element);
            const newMarker = L.marker(coords, { icon }).addTo(markersLayer);
            newMarker.on("mouseover", function (e) {
                this.openPopup();
            });
            newMarker.on("mouseout", function (e) {
                this.closePopup();
            });
            //newMarker.on("mouse")
            newMarker.bindPopup(
                "<b>"+element["municipio"] + " - " + element["uf"] +"</b><br>"+
                "<b>"+t("dashboard.graficos.titulo_atendimento_gripais")+":</b> "+element["total_gripal"]+"<br>"+
                "<b>"+t("dashboard.graficos.titulo_atendimento_totais")+":</b> "+element["total_geral"]+"<br>"+
                "<b>"+t("dashboard.dqi")+":</b> "+element["dqi"]+"<br>"+
                "<b>"+t("dashboard.table.ens")+":</b> "+element["sinal_ens_ivas"]+"<br>"+
                "<b>"+t("dashboard.table.evi")+":</b> "+element["sinal_evi_ivas"]+"<br>"+
                "<b>"+t("dashboard.table.glm")+":</b> "+element["sinal_glm_ivas"]+"<br>"+
                "<b>"+t("dashboard.table.ml")+":</b> "+element["sinal_ml_ivas"]+"<br>"+
                "<b>"+t("dashboard.ears")+":</b> "+element["sinal_ears_ivas"]+"<br>",
                {
                    minWidth: 450, // Largura mínima do popup
                    maxWidth: 450  // Largura máxima do popup
                }
            );
        }
    };

    function getCodEstadoByName(nome_estado)
    {
        let retorno = "";
        /*Object.keys(shapeFileBrasil.current["_layers"]).forEach((shape) => {
            if(shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["NM_UF"] === nome_estado){ 
                retorno = shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["CD_UF"];
            }
        });*/
        const keys = Object.keys(shapeFileBrasil.current["_layers"]);
        if (keys.length > 0) {
            for (let index = 0; index < keys.length; index++) {
                const key = keys[index];
                const element = shapeFileBrasil.current["_layers"][key];
                if(element !== undefined && element["feature"]["properties"]["NM_UF"] === nome_estado){ 
                    retorno = element["feature"]["properties"]["CD_UF"];
                    break;
                }
            }
        } 
        return retorno;
    }

   
    
    function plotaMarkerIvas(){
        let dados_centroids = [];
        //console.log("plotaMarkerIvas", listaMunicipios);

        if(markersLayer !== null){
            removeMarkers();
        }

        //console.log(indice);

        let variavelSinal = "sinal_"+indice.toLowerCase()+"_ivas";
                
        if(municipiosTodosEstados !== null && municipiosTodosEstados.length > 0){ 
            //console.log("plotaMarkerIvas 0");  
            if(dados_municipios_por_data !== null && dados_municipios_por_data["municipios"]){
                let codigo_estado = getCodEstadoByName(estadoSelecionado);
                //console.log("plotaMarkerIvas 1 ", dados_municipios_por_data, filtroDQIMapa); 
    
                for (let index = 0; index < dados_municipios_por_data["municipios"].length; index++) {
                    const element = dados_municipios_por_data["municipios"][index];  
                    /*if(element['cod_uf'].toString() === codigo_estado){*/
                        for(let i=0; i < municipiosTodosEstados.length; i++){
                            //let filtraDQIMapa = filtroDQIMapa.toLowerCase() === t("dashboard.apto").toLowerCase() || filtroDQIMapa.toLowerCase() === t("dashboard.nao_apto").toLowerCase();
                            //let exibeDQI = filtraDQIMapa ? ((element['dqi'] !== null && element['dqi'].toLowerCase() === "apto") || (element['dqi'] === null || element['dqi'].toLowerCase() === "não apto")) : true;
                            let dqiApto = element["dqi"] === "Apto" || element["dqi"] === "Bom";
                            let filtroDQIApto = filtroDQIMapa.toLocaleLowerCase() === "apto" || filtroDQIMapa.toLocaleLowerCase() === "fit";
                            let exibeFiltrandoDQI = isAllSelect(filtroDQIMapa) || ((!dqiApto && !filtroDQIApto) || (dqiApto && filtroDQIApto));

                            //console.log("exibeDQI", exibeFiltrandoDQI, element['dqi'].toLowerCase());    
                            if((exibeFiltrandoDQI) && element[variavelSinal] !== null && municipiosTodosEstados[i]["cod_ibge"].toString() === element["cod_ibge"].toString() && municipiosTodosEstados[i]["latitude"] != undefined && municipiosTodosEstados[i]["longitude"] != undefined){
                                let icons = null;
                                /*if(element['sinal_ens_ivas'] === 0.0){
                                    icons = createIcon(iconVerdeUrl);
                                } else*/ if(element[variavelSinal] === 0.5){
                                    icons = createIcon(iconAmareloUrl);
                                } else if(element[variavelSinal] === 1.0){
                                    icons = createIcon(iconVermelhoUrl);
                                }
                                //console.log("plotaMarkerIvas 2");
                                if(icons !== null){
                                    //console.log("plotaMarkerIvas 3");
                                    addMarker([municipiosTodosEstados[i]["latitude"], municipiosTodosEstados[i]["longitude"]], icons, element);
                                }
                            }
                        }
                    /*}*/
                }
            }
        }

        //criarLegenda(0,0,"ind", language);        
    }
    
    const removeMarkers = () => {
            markersLayer.clearLayers(); // Removendo todos os marcadores da layer
    };

    function getCodIbgeLayerShapefile(layer) {
        return (layer["feature"]["properties"]["CD_MUN"]);
    }

    const getCodEstadoBySigla = (sigla) => {
        for(let i = 0; i < cod_estados.length; i++){
            if(cod_estados[i]["UF"] === sigla){
                return cod_estados[i]["COD"];
            }
        }
    }

    const isNumeric = (value) => {
        return /^\d+(?:\.\d+)?$/.test(value); 
    }

    function carregaMunicipiosPorEstado(siglaEstado){
        if(!loading){
            setLoading(true);
        }
        //console.log("carregaMunicipiosPorEstado");
        if(siglaEstado !== ''){
            fetch(servidor + '/api/municipio/municipiosbysiglaestado/' + siglaEstado
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + _logado
                    }
                }
            )
            .then(response => {
                if (response.status === 401 || response.status === 404) {
                    setLogado(null);    
                    window.location.href = "/";
                }
                return response.json();
            })
            .then(function (myJson) {
                let listaTemp = [];
                let cidades_labels_tmp = [{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}];
                for(let i = 0; i < myJson.length; i++){
                    listaTemp.push({
                        "cod_ibge": myJson[i]["cod_ibge"],
                        "municipio": myJson[i]["municipio"],
                        "latitude": myJson[i]["y"],
                        "longitude": myJson[i]["x"]
                    });

                    cidades_labels_tmp.push({cod_ibge: myJson[i]["cod_ibge"],  label: myJson[i]["municipio"]});
                }

                setCidades_Labels(cidades_labels_tmp);

                listaTemp.sort((a, b) => a["municipio"].localeCompare(b["municipio"]));
                
                listaTemp.unshift({
                    "cod_ibge": 0,
                    "municipio": t("dashboard.todos")
                });

                setListaMunicipios(listaTemp); 

                //getDadosPorData(datas[idxDataSelecionada], language, true);
            }).catch(err => {
                console.error("Erro capturado 3:", err);
                debugger; // para pausar e inspecionar
            });;
        }
    }

    const comparaDataInicio = (data1, data2) => {        
        if(data1 === null || data2 === null)
            return false;
        return data1 >= data2;
    }

    const getIdxDataInicio = (datas_local) => {
        var idx = 0;
        for (let idx_data = 0; idx_data < datas_local.length; idx_data++) {
            if (comparaDataInicio(new Date(datas_local[idx_data]), dataInicial.current)) {
                idx = idx_data;
                break;
            }
        }
        return idx;
    }
    
    const getLastYear = (dt) => {
        let dt_local = new Date(dt);
        dt_local.setFullYear(dt_local.getFullYear() - Number(1));
        return dt_local;
    }

    useEffect(() => {

        //voltar
        let dtInicial = datas[idxDataSelecionada];
        dataInicial.current = getLastYear(dtInicial);
    
        let idxDataInicio = getIdxDataInicio(datas);
    
        setMinDate(datas[idxDataInicio]);
        setMinDateRangeInicial(inicioSemanas[idxDataInicio]);
        setMinDateRangeFinal(fimSemanas[idxDataInicio]);
        
        setMinIdxDate(idxDataInicio);
        setMaxDate(datas[idxDataSelecionada]);
        setMaxIdxDate(idxDataSelecionada);
        
        setMaxDateRangeInicial(inicioSemanas[idxDataSelecionada]);
        
        setMaxDateRangeFinal(fimSemanas[idxDataSelecionada]);
        /*atualizaRangeGraficos(idxDataInicio, "min", false);
        atualizaRangeGraficos(idxDataSelecionada, "max", false);*/
        setValueRangeData([idxDataInicio,idxDataSelecionada]);
        setSemanaSelecionada(semanas[idxDataSelecionada]);
        setInicioSemanaSelecionada(inicioSemanas[idxDataSelecionada]);
        setFimSemanaSelecionada(fimSemanas[idxDataSelecionada]);
        setInicioSemanaSelecionadaRange(semanas[idxDataInicio]);
        setFimSemanaSelecionadaRange(semanas[idxDataSelecionada]);
            
        getDadosPorData(datas[idxDataSelecionada], language, true);
        
        //atualizaTotalSinais(!isAllSelect(estadoSelecionado));
    
    }, [idxDataSelecionada]);

    const getNomeEstadoByCodIbge = (cod_ibge_local) => {
        let retorno = null;
        if(isNumeric(cod_ibge_local) && shapeFileBrasil.current !== null && shapeFileBrasil.current["_layers"] !== null){
            const keys = Object.keys(shapeFileBrasil.current["_layers"]);
            if (keys.length > 0) {
                for (let index = 0; index < keys.length; index++) {
                    const key = keys[index];
                    const element = shapeFileBrasil.current["_layers"][key];
                    if(element !== undefined){
                        let cod_temp = parseInt(element["feature"]["properties"]["CD_UF"]);
                        if(element["feature"]["properties"]["CD_UF"] === cod_ibge_local || cod_temp === cod_ibge_local){
                            retorno =  element["feature"]["properties"]["NM_UF"];
                            break;
                        } 
                    } else {
                        retorno = cod_ibge_local;
                    }
                }
            }  
        }
        else {
            retorno = cod_ibge_local;
        }
        return retorno;
    }

    function FormatarDoisDigitos(numero) {
        if(numero === null || numero === undefined)
            return "00";
        return numero.toString().padStart(2, '0');
    }

    function extraiAno(data){
        if(data && data.length > 0)
            return data.substring(0,4);
        else 
            return "";
    }

    function onEachFeatureEstado(feature, layer) {
        layer.on({
            mouseover: function (e) {
                var layer = e.target;
                // Adiciona um popup com o nome do município
                if (feature.properties && feature.properties.NM_MUN) {
                    layer.bindPopup(feature.properties.NM_MUN + " - " + feature.properties.SIGLA_UF, {
                        className: "popup-estilo"
                    }).openPopup();
                }
            },
            mouseout: function (e) {
                var layer = e.target;
                //shapeFileMunicipios.resetStyle(layer);
                layer.closePopup();
            },
            click: () => {
                if(cod_ibge === getCodIbgeLayerShapefile(layer)){
                    map.current.fitBounds(layer.getBounds().pad(1));
                    return;
                }

                setLoading(true);
   
                //resetShapeFile(estadoSelecionado, municipioSelecionado, true);

                let siglaEstadoSelecionada = feature["properties"]["SIGLA_UF"];

                let codEstadoSelecionado = getCodEstadoBySigla(siglaEstadoSelecionada);

                let nomeEstadoSelecionado = getNomeEstadoByCodIbge(codEstadoSelecionado);

                if(estadoSelecionado !== nomeEstadoSelecionado){
                    carregaMunicipiosPorEstado(siglaEstadoSelecionada);

                    setEstadoSelecionado(nomeEstadoSelecionado);
                }

                setMunicipioSelecionado(layer['feature']['properties']['NM_MUN']/*getNomeCidadeWhereCodIbge(getCodIbgeLayerShapefile(layer))*/);
                setCod_Ibge(getCodIbgeLayerShapefile(layer));

                layer.setStyle({ weight: weightSelecao, color: "black", fillOpacity: opacidadeMunicipio  });
                zoomPorClique = true;
                map.current.fitBounds(layer.getBounds().pad(1));
            },
            
        });
    }

    const getCodIbgeCidadeWhereNome = (cod_ibge_local) => {
        let retorno = null;
        if(!isNumeric(cod_ibge_local) || (cod_ibge_local.length === 6)){
              
            const keys = Object.keys(shapeFileMunicipios.current["_layers"]);
            if (keys.length > 0) {
                for (let index = 0; index < keys.length; index++) {
                    const key = keys[index];
                    const elementLoop = shapeFileMunicipios.current["_layers"][key];
                    let cod_temp = elementLoop["feature"]["properties"]["CD_MUN"].substring(0, 6);
                    if(elementLoop["feature"]["properties"]["NM_MUN"] === cod_ibge_local || cod_temp === cod_ibge_local){
                        retorno =  elementLoop["feature"]["properties"]["CD_MUN"];
                        break;
                    } 
                }
            } 
        }
        else {
            retorno = cod_ibge_local;
        }
        return retorno;
    }

    useEffect(() => {
        let siglaEstado = '';
        let codigo_estado = 0;

        if(shapeFileBrasil.current !== null){
            Object.keys(shapeFileBrasil.current["_layers"]).forEach((shape) => {
                if(isAllSelect(estadoSelecionado)){
                    shapeFileBrasil.current["_layers"][shape].setStyle({ weight: weightNormal, color: /*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaBrasilWhite*/"black" , fillColor: /*'#E63100'*//*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaWhite*/ transparenciaDefaultMapa, fillOpacity: 0.5 });
                } else
                if(shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["NM_UF"] === estadoSelecionado){ 
                    siglaEstado = shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["SIGLA_UF"];
                    codigo_estado = shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["CD_UF"];
                    shapeFileBrasil.current["_layers"][shape].setStyle({ weight: 2, color: "black" /*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaWhite*//*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaBrasilWhite/*transparenciaDefaultMapa*/, fillColor: /*'#E63100'*//*theme === "dark" ? cinzaDefaultMapa : cinzaDefaultMapaWhite*/ transparenciaDefaultMapa, fillOpacity: 0.5 });
                } else {
                    shapeFileBrasil.current["_layers"][shape].setStyle({ weight: weightNormal, color: /*transparenciaDefaultMapa*/"black", fillColor: /*transparenciaDefaultMapa*/ "black", fillOpacity: transparencia.current });   
                }
            });
        }

        if(isAllSelect(estadoSelecionado) && (!isAllSelect(municipioSelecionado) || isAllSelect(municipioSelecionado))){
            if(map.current !== null){
                const defaultCenter = position;
                const { innerWidth: width, innerHeight: height } = window;
                if(width < 1300)
                    map.current.setView([-13.338793, -45.206666], defaultZoom);
                else 
                    map.current.setView(defaultCenter, defaultZoom);
            }
        }

        if(isAllSelect(estadoSelecionado) && !isAllSelect(municipioSelecionado)){
            setMunicipioSelecionado(t("dashboard.todos"));
        }

        if(!isAllSelect(municipioSelecionado)){
            getMunicipioTodoPeriodo(municipioSelecionado, true);
            return;
        }

        setLoading(true);

        /*if(shapeFileBrasil.current !== null){
            */
            if(codigo_estado === 0){
                setListaMunicipios(getCidades());
                let cidades_labels_tmp = [{cod_ibge: t("dashboard.todos"), label: t("dashboard.todos")}];
                setCidades_Labels(cidades_labels_tmp);
            }

            carregaDadosEstado(codigo_estado, siglaEstado);
        /*}*/
        setLoading(false);
    }, [estadoSelecionado, municipioSelecionado]);

    const handleChangeDQIFiltroMapa = (event) => {
        setFiltroDQIMapa(event.target.value);
    };

    const getDadosPorData = (dt, linguagem, pintaCirculo) => {
        var path_dir = "semanal";
        if (dt !== undefined && dt !== null && dt !== 0) {            
            fetch(servidor + '/api/dadosdoenca/municipiosbydate/' +  dt.replace(" 00:00:00", "") + "/1"
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + _logado
                    }
                }
            )
                .then(response => {
                    if (response.status === 401  || response.status === 404) {
                        setLogado(null);    
                        window.location.href = "/";
                    }
                    return response.json();
                })
                .then(function (myJson) {
                    //let tempCidadesTabela = [];
                    setDados_Municipios_Por_Data(myJson);
                    
                     /*atualizaTotalSinais(!isAllSelect(estadoSelecionado), myJson);
                    if(myJson !== null ){
                        tempMakersMediaMovel = [];
                        for(let x = 0; x < myJson["municipios"].length; x++){
                            tempMakersMediaMovel.push(
                                criaTempMakersMediaMovelMunicipal(myJson["municipios"][x], myJson['data'], myJson['semana'])
                               );
                        }
                    }

                   if(shapeFileMunicipios.current !== null){
                        plotaMapa(myJson["municipios"], "getDadosPorData");

                        criaPopups(tempMakersMediaMovel);
                    }  

                    setMarkers( tempMakersMediaMovel);*/
                    
                }).catch(err => {
                    console.error("Erro capturado 4:", err);
                    debugger; // para pausar e inspecionar
                });;
        }
    }

    const getMunicipioTodoPeriodo = (cod_ibge_local, pintaCirculo) => {
        cod_ibge_local = getCodIbgeCidadeWhereNome(cod_ibge_local);
        
        /*if (pintaCirculo && shapeFileMunicipios.current !== null) {
            
            Object.keys(shapeFileMunicipios.current["_layers"]).forEach((shape) => {        
                if (cod_ibge_local === getCodIbgeShapefile(shapeFileMunicipios.current, shape).toString()) {
                  
                    shapeFileMunicipios.current["_layers"][shape].setStyle({ weight: weightSelecao, color: "black", fillOpacity: opacidadeMunicipio });
                    if(cod_ibge != cod_ibge_local)
                        map.current.fitBounds(shapeFileMunicipios.current["_layers"][shape].getBounds().pad(1));
                } else {
                    let corBordaAnt = shapeFileMunicipios.current["_layers"][shape]["options"]["fillColor"];
                    if(corBordaAnt === "#dddcdf"){
                        corBordaAnt = "black";
                    }
                    if(corBordaAnt === corMapa1){
                        corBordaAnt = theme === "dark" ? corMapa1BordaDark : corMapa1Borda;
                    } else if(corBordaAnt === cinzaDefaultMapaDark || corBordaAnt === cinzaDefaultMapaBorda || corBordaAnt === transparenciaDefaultMapa){
                        corBordaAnt = theme === "dark" ? cinzaDefaultMapaDark : cinzaDefaultMapaBorda;
                    }                     

                    shapeFileMunicipios.current["_layers"][shape].setStyle({ weight: weightNormal, color: corBordaAnt, fillOpacity: opacidadeMunicipio });
                }
            });            
        }*/

        var path_dir = "semanal";
        
        fetch(servidor + '/api/dadosdoenca/alldatebymunicipio/' + cod_ibge_local + "/1"
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + _logado
                }
            }
        )
        .then(response => {
            if (response.status === 401 || response.status === 404) {
                setLogado(null);    
                window.location.href = "/";
            }
            return response.json();
        })
        .then(function (myJson) {
            setDados_Municipio_Selecionado(myJson);
        }).catch(err => {
            console.error("Erro capturado 5:", err);
            debugger; // para pausar e inspecionar
        });; 
    }

    useEffect(() => {
        plotaMarkerIvas();
        plotaMapa();
    }, [indice, filtroDQIMapa]);

    useEffect(() => {
        plotaMarkerIvas();
        if(shapeFileMunicipios.current != null)
            plotaMapa();

        if(dados_Municipio !== null){
            let arrayT2M = [];
            let arrayRH2M = [];
            let arrayPRECTOTCORR = [];
            let arrayAtendIvas = [];
            let contador = 0;
            Object.keys(dados_Municipio).forEach((key) => {
                contador++;
                var obj = {};
                //converte element["epidemi_cal_start"] para date
                //let data_grafico = Date.parse();
                //let data_grafico = new Date(element["epidemi_cal_start"]);
                let element = dados_Municipio[key];
                let data_grafico = /*parseISO(element["epidemi_cal_start"]);*/ /*new Date(*/element["epidemi_cal_start"]/*)*/;
                //console.log(element);
                //let 
                //let data_grafico =  element["epidemi_cal_start"] //converterDiaDoAnoParaData(dados_Municipio["dados"][i]["YEAR"], dados_Municipio["dados"][i]["DOY"]);
                /*if(element["epiyear"] >= 2021){*/
                    //pesquise no dados_municipio_selecionado["atendimentos"]["data"] por data_grafico
                    if(dados_municipio_selecionado !== null && dados_municipio_selecionado["atendimentos"]){
                        const keys = Object.keys(dados_municipio_selecionado["atendimentos"]);
                        if (keys.length > 0) {
                            for(let i = 0; i < keys.length; i++){
                                const key = keys[i];
                                const elementLoop = dados_municipio_selecionado["atendimentos"][key];
                                //console.log(/*elementLoop,*/ elementLoop["data_inicial_semana"].substring(0, 10) === data_grafico, data_grafico, elementLoop["data_inicial_semana"].substring(0, 10));
                                if(elementLoop["data_inicial_semana"].substring(0, 10) === data_grafico){
                                    //console.log(elementLoop);
                                    var obj4 = {};
                                    obj4['data'] = data_grafico;
                                    obj4['total'] = elementLoop["total_gripal"];
                                    arrayAtendIvas.push(obj4);
                                    break;
                                }
                            }
                        }
                    }

                    obj['data'] = data_grafico;
                    obj['total'] = element["t2m_mean"];
                    if(contador === dados_Municipio.length - 1)
                        setUltimoValorTEMP(element["t2m_mean"]);
                    arrayT2M.push(obj);

                    var obj2 = {};
                    obj2['data'] = data_grafico;
                    obj2['total'] = element["rh2m_std"];
                    arrayRH2M.push(obj2);
                    if(contador === dados_Municipio.length - 1)
                        setUltimoValorUM(element["rh2m_std"]);

                    var obj3 = {};
                    obj3['data'] = data_grafico;
                    obj3['total'] = element["prectotcorr_mean"];
                    arrayPRECTOTCORR.push(obj3);
                    if(contador === dados_Municipio.length - 1)
                        setUltimoValorPREC(element["prectotcorr_mean"]);
                //}
            });                
                
                /*if(dados_Municipio["dados"][i]["YEAR"] >= 2021){
                    obj['data'] = data_grafico;
                    obj['total'] = element["T2M"];
                    if(i === dados_Municipio["dados"].length - 1)
                        setUltimoValorTEMP(element["T2M"]);
                    arrayT2M.push(obj);

                    var obj2 = {};
                    obj2['data'] = data_grafico;
                    obj2['total'] = element["RH2M"];
                    arrayRH2M.push(obj2);
                    if(i === dados_Municipio["dados"].length - 1)
                        setUltimoValorUM(element["RH2M"]);

                    var obj3 = {};
                    obj3['data'] = data_grafico;
                    obj3['total'] = element["PRECTOTCORR"];
                    arrayPRECTOTCORR.push(obj3);
                    if(i === dados_Municipio["dados"].length - 1)
                        setUltimoValorPREC(element["PRECTOTCORR"]);
                }*/
           // }

           //console.log(arrayAtendIvas);

            arrayT2M = Object.fromEntries(
                arrayT2M.map(({ data, total }) => [data, total])
            );

            arrayRH2M = Object.fromEntries(
                arrayRH2M.map(({ data, total }) => [data, total])
            );

            arrayPRECTOTCORR = Object.fromEntries(
                arrayPRECTOTCORR.map(({ data, total }) => [data, total])
            );

            arrayAtendIvas = Object.fromEntries(
                arrayAtendIvas.map(({ data, total }) => [data, total])
            );

            setDadosGraficoTemp(
                getDadosGraficoTemp(arrayT2M, arrayAtendIvas)
            ); 

            setDadosGraficoUm(
                getDadosGraficoUm(arrayRH2M, arrayAtendIvas)
            ); 

            setDadosGraficoPrec(
                getDadosGraficoPrec(arrayPRECTOTCORR, arrayAtendIvas)
            ); 

            setDadosGraficoTempFull(
                getDadosGraficoTemp(arrayT2M, arrayAtendIvas, true)
            ); 

            setDadosGraficoUmFull(
                getDadosGraficoUm(arrayRH2M, arrayAtendIvas, true)
            ); 

            setDadosGraficoPrecFull(
                getDadosGraficoPrec(arrayPRECTOTCORR, arrayAtendIvas, true)
            ); 
        } else {
            setDadosGraficoTemp(getDadosGraficoTemp([]));
            setDadosGraficoUm(getDadosGraficoUm([]));
            setDadosGraficoPrec(getDadosGraficoPrec([]));
            setDadosGraficoPrecFull(getDadosGraficoPrec([], true));
            setDadosGraficoTempFull(getDadosGraficoTemp([], true));
            setDadosGraficoUmFull(getDadosGraficoUm([], true));
            setUltimoValorPREC(null);
            setUltimoValorTEMP(null);
            setUltimoValorUM(null);
        }
    }, [dados_municipios_por_data, dados_Municipio, dados_municipio_selecionado]);

    useEffect(() => {
        plotaMarkerIvas();
    }, [listaMunicipios]);

    function carregaDadosEstado(codigo_estado, siglaEstado){
        if(!loading){
            setLoading(true);
        }
        
        let dadosTemp = [];
        let dados2Temp = [];
        let dados3Temp = [];
        let dados4Temp = [];
        let dados_variacao_media_movelTemp = [];
        let dados_media_movelTemp = [];
        
        let dadosEVI = [];
        let dadosMU = [];
        let dadosEXC = [];

        let dados_o_numTemp = [];
        let dados_e_thrTemp = [];
        let dados_u_b_thrTemp = [];
        let dados_e_h_estimateTemp = [];
        let dados_p_e_h_estimateTemp = [];

        var acumulado_gripal = 0;

        if(codigo_estado !== 0){
           /* Object.keys(shapeFileBrasil.current["_layers"]).forEach((shape) => {
                if(shapeFileBrasil.current["_layers"][shape]["feature"]["properties"]["NM_UF"] === estadoSelecionado){
                   map.current.fitBounds(shapeFileBrasil.current["_layers"][shape].getBounds());
                }                
            });*/

            const keys = Object.keys(shapeFileBrasil.current["_layers"]);
            if (keys.length > 0) {
                for (let index = 0; index < keys.length; index++) {
                    const key = keys[index];
                    const element = shapeFileBrasil.current["_layers"][key];
                    if(element !== undefined && element["feature"]["properties"]["NM_UF"] === estadoSelecionado){
                        map.current.fitBounds(element.getBounds());
                        break;
                    } 
                }
            } 
            
            /*
            fetch('Dados/dados_estados/estados/dados_' + codigo_estado + '.json'
                , {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            )
                .then(function (response) {
                    //Limpa pontos anteriores
                    return response.json();
                })
                .then(function (myJson) {
                    dados_estado.current = myJson;

                    for (let index = 0; index < dados_estado.current["atendimentos"].length; index++) {
                        const element = dados_estado.current["atendimentos"][index];

                        var obj = {};
                        obj['data'] = element["data"];
                        obj['total'] = element["total_geral"];
                        dadosTemp.push(obj);

                        var obj2 = {};
                        obj2['data'] = element["data"];
                        obj2['total'] = element["total_gripal"];
                        dados2Temp.push(obj2);

                        if(element["data"] <= maxDate && element["data"] >= minDate){
                            if(dadosGraficoAtendimentosGripaisMaxValue.current === null || dadosGraficoAtendimentosGripaisMaxValue.current < obj2['total']){
                                dadosGraficoAtendimentosGripaisMaxValue.current = obj2['total'];
                            }
                        } 

                        var obj3 = {};
                        obj3['data'] = element["data"];
                        obj3['total'] = (element["total_gripal"] / element["total_geral"]) * 100;
                        dados3Temp.push(obj3);

                        acumulado_gripal += element["total_gripal"];

                        var obj4 = {};
                        obj4['data'] = element["data"];
                        obj4['total'] = acumulado_gripal;
                        dados4Temp.push(obj4);

                        var obj5 = {};
                        obj5['data'] = element["data"];
                        obj5['total'] = element["media_movel_ivas"];
                        dados_media_movelTemp.push(obj5);

                        var obj6 = {};
                        obj6['data'] = element["data"];
                        obj6['total'] = element["variacao_media_movel"];
                        dados_variacao_media_movelTemp.push(obj6);

                        var obj8 = {};
                        obj8['data'] = element["data"];
                        if(indice.toLowerCase() === "mmaing"){
                            obj8['total'] = element["lim_esp_ml_ivas"];
                        } else if(indice.toLowerCase() === "ens"){
                            obj8['total'] = element["lim_esp_ens_ivas"];
                        } else if(indice.toLowerCase() === "evi"){
                            obj8['total'] = element["lim_esp_evi_ivas"];
                        } else if(indice.toLowerCase() === "ears"){
                            obj8['total'] = element["lim_esp_ears_ivas"];
                        } else if(indice.toLowerCase() === "glm"){
                            obj8['total'] = element["lim_esp_glm_ivas"];
                        }
                        //obj8['total'] = indice.toLowerCase() === "ml" ? element["lim_esp_ml_ivas"] : indice.toLowerCase() === "ens" ? element["lim_esp_ens_ivas"] : indice.toLowerCase() === "evi" ? element["lim_esp_evi_ivas"] : element["lim_esp_ears_ivas"];
                        dadosMU.push(obj8);

                        var obj9 = {};
                        obj9['data'] = element["data"];
                        if(indice.toLowerCase() === "mmaing"){
                            obj9['total'] = element["exc_ml_ivas"];
                        } else if(indice.toLowerCase() === "ens"){
                            obj9['total'] = element["exc_ens_ivas"];
                        } else if(indice.toLowerCase() === "evi"){
                            obj9['total'] = element["exc_evi_ivas"];
                        } else if(indice.toLowerCase() === "ears"){
                            obj9['total'] = element["exc_ears_ivas"];
                        } else if(indice.toLowerCase() === "glm"){
                            obj9['total'] = element["exc_glm_ivas"];
                        }
                        //obj9['total'] = indice.toLowerCase() === "ml" ? element["exc_ml_ivas"] : indice.toLowerCase() === "ens" ? element["exc_ens_ivas"] : indice.toLowerCase() === "evi" ? element["exc_evi_ivas"] : element["exc_ears_ivas"];
                        dadosEXC.push(obj9);
                    }

                    dadosTemp = Object.fromEntries(
                        dadosTemp.map(({ data, total }) => [data, total])
                    );
            
                    dados2Temp = Object.fromEntries(
                        dados2Temp.map(({ data, total }) => [data, total])
                    ); 
            
                    dados3Temp = Object.fromEntries(
                        dados3Temp.map(({ data, total }) => [data, total])
                    );
            
                    dados4Temp = Object.fromEntries(
                        dados4Temp.map(({ data, total }) => [data, total])
                    );

                    dados_media_movelTemp = Object.fromEntries(
                        dados_media_movelTemp.map(({ data, total }) => [data, total])
                    );

                    dadosMU = Object.fromEntries(
                        dadosMU.map(({ data, total }) => [data, total])
                    );

                    dadosEXC = Object.fromEntries(
                        dadosEXC.map(({ data, total }) => [data, total])
                    );

                    dados_variacao_media_movelTemp = Object.fromEntries(
                        dados_variacao_media_movelTemp.map(({ data, total }) => [data, total])
                    );


                    setDadosGraficoTotalAtendimentos(
                        getDadosGraficoTotalAtendimentos(dadosTemp)
                    ); 
            
                    setDadosTotalAtendimentosGripais(dados2Temp);

                    setDadosGraficoTotalAtendimentosGripais(
                        getDadosGraficoTotalAtendimentosGripais(dados2Temp)
                    );

                    setDadosGraficoTotalAtendimentosFull(
                        getDadosGraficoTotalAtendimentos(dadosTemp, true)
                    );
            
                    setDadosGraficoTotalAtendimentosGripaisFull(
                        getDadosGraficoTotalAtendimentosGripais(dados2Temp, true)
                    );

                    setDadosGraficoRazaoAtendimentosGripais(
                        //getDadosGraficoRazaoAtendimentosGripais(dadosEVI, dados3Temp)
                        getDadosGraficoRazaoAtendimentosGripais(dados_media_movelTemp, dados3Temp)
                    );

                    setDadosGraficoLimite(
                        getDadosGraficoLimite(dados2Temp, dadosMU)
                    )
        
                    setDadosGraficoLimiteFull(
                        getDadosGraficoLimite(dados2Temp, dadosMU, true)
                    ) 

                    setDadosGraficoExcesso(
                        getDadosGraficoExcesso(dadosEXC)
                    ) 
                    setDadosGraficoExcessoFull(
                        getDadosGraficoExcesso(dadosEXC, true)
                    )

                    setDadosGraficoTaxaMediaMovel(
                        getDadosGraficoTaxaMediaMovel(dados_variacao_media_movelTemp)
                    );
        
                    setDadosGraficoTaxaMediaMovelFull(
                        getDadosGraficoTaxaMediaMovel(dados_variacao_media_movelTemp)
                    );

                });*/

                carregaMunicipiosPorEstado(siglaEstado);
        } 
    }

    const plotaMapa = () => {
        if(shapeFileMunicipios.current === null)
            return;
        Object.keys(shapeFileMunicipios.current["_layers"]).forEach((shape) => {
            var cod_ibge_tmp = getCodIbgeShapefile(shapeFileMunicipios.current, shape);
            let transparenciaFill = /*theme === "dark" ? "#8d8d8f" : "#e5e5e6"*/"rgba(255,255,255,0)";
            
                    var cor = transparenciaFill;
                    var corContorno = theme === "dark" ? cinzaDefaultMapaDark : cinzaDefaultMapaBorda;
    
                    let weight_ = weightNormal;
                    
                    if (cod_ibge === shapeFileMunicipios.current["_layers"][shape]["feature"]["properties"]["CD_MUN"]) {

                        cor = transparenciaFill;
                        corContorno = /*theme === "dark" ? cinzaDefaultMapaDark : cinzaDefaultMapaBorda*/"black";
                        weight_ = weightSelecao;     

                    }

                    if(dados_municipios_por_data !== null && dados_municipios_por_data["municipios"]){
                        for(let i = 0; i < dados_municipios_por_data["municipios"].length; i++){
                            let elemento = dados_municipios_por_data["municipios"][i];
                            
                            //
                            if(elemento["cod_ibge"].toString() === cod_ibge_tmp){
                                //console.log(elemento["cod_ibge"].toString(), cod_ibge_tmp);
                                if(filtroDQIMapa === t("dashboard.apto")){
                                    if(elemento["dqi"] === null || elemento["dqi"].toLowerCase() === "não apto"){
                                        //console.log(elemento["dqi"], "não apto");
                                        cor = theme === "dark" ? corMapaNaoAptoDark : corMapaNaoApto;
                                    }
                                } else if(filtroDQIMapa === t("dashboard.nao_apto")){
                                    if(elemento["dqi"] === null || elemento["dqi"].toLowerCase() === "apto"){
                                        //console.log(elemento["dqi"], "não apto");
                                        cor = theme === "dark" ? corMapaNaoAptoDark : corMapaNaoApto;
                                    }   
                                }
                                break;
                            }
                        }
                    }
    
                    /*if(corContorno === undefined){
                        corContorno = cor;
                    }*/
    
                    shapeFileMunicipios.current["_layers"][shape].setStyle({ weight: weight_, color: corContorno, fillColor: cor, fillOpacity: opacidadeMunicipio});                                
        });   

        setLoading(false); 
    }

    const handleChangeRangeData = (event, newValue) => {
        if(newValue[0] != minIdxDate){
            atualizaRangeGraficos(newValue[0], "min", true);
        } else if(newValue[1] != maxIdxDate) {    
            atualizaRangeGraficos(newValue[1], "max", true);
        }
    };

    const atualizaRangeGraficos = (valor, tipo, validacao) => {
        if(validacao){
            if(tipo === "max"){
                if(parseInt(valor) <= (parseInt(minIdxDate) + 1)){

                    return;
                }
            } else {
                if(parseInt(valor) >= (parseInt(maxIdxDate) - 1) ){
                    valor = parseInt(maxIdxDate) - 2;
                    //return;
                }
            } 
        }

        if (tipo === "max") {
            setMaxDate(datas[valor]);
            setFimSemanaSelecionada(fimSemanas[valor]);
            setMaxIdxDate(valor);
            setValueRangeData([minIdxDate,valor]);

            setIdxDataSelecionada(valor);
            setDataSelecionada(datas[valor]);
            setSemanaSelecionada(semanas[valor]);
            
            setInicioSemanaSelecionadaRange(semanas[minIdxDate]);
            setFimSemanaSelecionadaRange(semanas[valor]);

            setMinDateRangeInicial(inicioSemanas[minIdxDate]);
            setMinDateRangeFinal(fimSemanas[minIdxDate]);
            setMaxDateRangeInicial(inicioSemanas[valor]);
            
            setMaxDateRangeFinal(fimSemanas[valor]);
            
        } else {
            setMinDate(datas[valor]);
            setMinDateRangeInicial(inicioSemanas[valor]);
            setMinDateRangeFinal(fimSemanas[valor]);
            setMaxDateRangeInicial(inicioSemanas[maxIdxDate]);
            
            setMaxDateRangeFinal(fimSemanas[maxIdxDate]);

            setInicioSemanaSelecionadaRange(semanas[valor]);
            setFimSemanaSelecionadaRange(semanas[maxIdxDate]);
            setMinIdxDate(valor);
            
            setValueRangeData([valor,maxIdxDate]);
        }
    }

    function handleChangeAvisos() {
        setCheckedAvisos(!checkedAvisos);
    }

    useEffect(() => {
        if (map.current && markersLayer) {
            if (checkedAvisos) {
                markersLayer.addTo(map.current); // Torna visível
            } else {
                map.current.removeLayer(markersLayer); // Torna invisível
            }
            preparaColorMap();
        }
    }, [checkedAvisos]);



    return (
        <Container className="container_Mapa">
            {loading && <div className={style.loading}><div className={style.lds_ring}><div></div><div></div><div></div><div></div></div></div>}

            <Row>
                <TabNav theme={theme} language={language} currentPage={"Clima"} link_gripe="" link_zika= {link_zika}/>

                <Row>
                    <div className="div_top_clima">

                        <div className={style.div_top}>
                            <div className='titulo_semana_ep'>
                                <Translator path="dashboard.semana_ep" />: {FormatarDoisDigitos(semanaSelecionada) + "-" + extraiAno(dataSelecionada)} 
                            </div>
                            <div className={style.lado_a_lado}>
                                <a href="#" className={`${style.previous} ${style.round}`} onClick={() => { mudarData((parseInt(idxDataSelecionada) - 1), datas) }}>&#8249;</a>
                                <Box sx={{ width: "150px", paddingTop:"0px", marginTop:"0px" }}>
                                    <Slider 
                                        id="sel_data"
                                        value={idxDataSelecionada} 
                                        max={maxLengthData} 
                                        min={0} 
                                        aria-label="Default" 
                                        valueLabelDisplay="off" 
                                        onChange={handleChangeSelectData}
                                    />
                                </Box>
                                <a href="#" className={`${style.next} ${style.round}`} onClick={() => { mudarData((parseInt(idxDataSelecionada) + 1), datas) }}>&#8250;</a>
                                <div className='dataSemana'>
                                    <Moment date={inicioSemanaSelecionada} format='DD/MM/YYYY'></Moment>&nbsp;<Translator path="dashboard.a"/>&nbsp;<Moment date={fimSemanaSelecionada} format='DD/MM/YYYY'></Moment>
                                </div>
                            </div>
                            <div className={style.container_seleciona_municipio_e_cor}>
                                <div className={style.seleciona_municipio}> 
                                    
                                    <Autocomplete
                                        {...defaultProps}
                                        disableClearable
                                        id="autocomplete_estado"
                                        className='change_color_text'
                                        isOptionEqualToValue={(option, value) => option.label === value.label}
                                        value={{label:estadoSelecionado}}
                                        onChange={(event, newValue) => {
                                            setLoading(true);
                                            setEstadoSelecionado(newValue.label);
                                            setCod_Ibge(t("dashboard.todos"));
                                            setMunicipioSelecionado(t("dashboard.todos"));
                                        }}
                                        renderInput={(params) => (
                                            <TextField className='autocomplete_estado_textfield' {...params} label={t("dashboard.estado")} size="small"/>
                                        )}
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    
                                    <Autocomplete
                                        {...defaultPropsMunicipio}
                                        disableClearable
                                        id="autocomplete_municipio"
                                        className='change_color_text'
                                        isOptionEqualToValue={(option, value) => option.cod_ibge === value.cod_ibge}
                                        value={{cod_ibge:cod_ibge, label:municipioSelecionado}}
                                        onChange={(event, newValue) => {
                                            handleChangeMunicipioNome(newValue.cod_ibge);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label={t("dashboard.cidade")} size="small"/>
                                        )}
                                    />

                                    <FormControl className={style.controlind}>
                                        <InputLabel id="demo-simple-select-label">{t("dashboard.titulo_mapa_evi")}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={indice}
                                            onChange={handleChangeIndicador}
                                            label={t("dashboard.titulo_mapa_evi")}
                                            name={"sinais_aviso"}
                                            sx={{ width: 120, height: 32}}
                                        >
                                        {listaSinaisAviso.map((e, key) => {
                                            return (
                                                <MenuItem key={key} value={e["sinal"]}>{e["nome"]}</MenuItem>
                                            );
                                        })}
                                        </Select>
                                    </FormControl> 
                                    
                                    <FormControl className={style.controlind}>
                                        <InputLabel id="demo-simple-select-label">DQI</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={filtroDQIMapa}
                                            label="DQI"
                                            onChange={handleChangeDQIFiltroMapa}
                                            sx={{ width: 100, height: 32}}
                                        >
                                        <MenuItem value={t("dashboard.todos")}>{t("dashboard.todos")}</MenuItem>
                                        <MenuItem value={t("dashboard.apto")}>{t("dashboard.apto")}</MenuItem>
                                        <MenuItem value={t("dashboard.nao_apto")}>{t("dashboard.nao_apto")}</MenuItem>
                                        </Select>
                                    </FormControl>   

                                    <FormControl id="controle-selecao-indicador">
                                    <InputLabel id="demo-simple-select-label">{t("dashboard.variavel")}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={variavel}
                                        onChange={(event) => setVariavel(event.target.value)}
                                        label={t("dashboard.variavel")}
                                        name={"variavel"}
                                        sx={{ width: 480, height: 32}}
                                    >
                                    {listaVariaveisClima.map((e, key) => {
                                        return (
                                            <MenuItem key={key} value={e["value"]}>{e["nome"]}</MenuItem>
                                        );
                                    })}
                                    </Select>
                                </FormControl>

                                <FormControl id="controle-selecao-indicador">
                                    <InputLabel id="demo-simple-select-label">{"ColorMap"}</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select-climate"
                                        value={mapa_cor_value}
                                        onChange={(event) => setMapa_Cor_Value(event.target.value)}
                                        label={"ColorMap"}
                                        name={"sinais_aviso"}
                                        sx={{ width: 200, height: 32}}
                                    >
                                    {listaColorMap.map((e, key) => {
                                        return (
                                            <MenuItem key={key} value={e["value"]}>{e["nome"]}</MenuItem>
                                        );
                                    })}
                                    </Select>
                                </FormControl> 

                                <FormControlLabel
                                    sx={{fontSize: "10px"}}
                                    control={
                                        <Switch checked={checkedAvisos} onChange={handleChangeAvisos} />
                                    }
                                    label=  {
                                            <Typography sx={{ fontSize: '12px' }}>
                                                Avisos
                                            </Typography>
                                            }
                                    labelPlacement="start" // Esta propriedade coloca o label antes do switch
                                    
                                />                                
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </Row>
                <Row>
                    <Col md={12}>
                        <div className={style.mapa}>
                            <div id="map" className={style.map}>

                            </div>
                        </div>
                    </Col>
                </Row>
                <div className='espacamento'></div>
                {!isAllSelect(municipioSelecionado) && (
                <div className={style.seleciona_periodo_semana}>
                    <div className={style.titulo_semana_ep}>
                        <Translator path="dashboard.semana_ep" />: {FormatarDoisDigitos(inicioSemanaSelecionadaRange)+ "-" + extraiAno(minDateRangeFinal)}&nbsp;<Translator path="dashboard.a"/>&nbsp;{FormatarDoisDigitos(fimSemanaSelecionadaRange)+ "-" + extraiAno(maxDateRangeFinal)}
                    </div>
                </div>)}
                {!isAllSelect(municipioSelecionado) && (
                <div className={style.seleciona_periodo}>
                    <div className='dataSemanaRange'>
                        <Moment date={minDateRangeInicial} format='DD/MM/YYYY'></Moment>&nbsp;<Translator path="dashboard.a"/>&nbsp;<Moment date={minDateRangeFinal} format='DD/MM/YYYY'></Moment>
                    </div>
                    <Box sx={{width: "220px", paddingTop:"0px", marginTop:"-5px" }}>
                        <Slider
                            getAriaLabel={() => 'Date range'}
                            value={valueRangeData}
                            onChange={handleChangeRangeData}
                            valueLabelDisplay="off"
                            min={0}
                            max={datas != null ? datas.length - 1 : 0}
                        />
                    </Box>
                    <div className='dataSemanaRange'>
                        <Moment date={maxDateRangeInicial} format='DD/MM/YYYY'></Moment>&nbsp;<Translator path="dashboard.a"/>&nbsp;<Moment date={maxDateRangeFinal} format='DD/MM/YYYY'></Moment>
                    </div>
                </div>)}
                {!isAllSelect(municipioSelecionado) && (
                <Row>

                    <div className="container_grafico">
                        <div className="header_grafico">
                            {t("dashboard.graficos.titulo_temp")}
                            <img className="img_info ocultar" src="flu/imagens/info32.png"></img>
                        </div>
                        <div className="body_grafico" style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
          
                            <div className={`${style.grafico_pg}`} style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                <Button className={`button_maximize ${style.button_maximize} ${style.float_right}`} onClick={() => setModal1Show(true)}></Button>
                                <Line onClick={() => setModal1Show(true)} options={getOptions_Line(theme, false, t("dashboard.graficos.titulo_temp"))} data={dadosGraficoTemp} />
                            </div>
                         
                            <div className={style.resumo_grafico} style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                <div className={style.titulo_resumo_grafico}>
                                    {t("dashboard.semana_ep")+" "} {semanas[semanas.length - 1]} 
                                </div>
                                <div className={style.valor_resumo} style={{color:  theme === "dark" ? "white" : "black" , backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                    {ultimoValorTEMP !== null ? ultimoValorTEMP.toFixed(2) : 0} ºC
                                </div>
                                {t("dashboard.graficos.titulo_temp")}
                                <br></br>
                            </div>
                        </div>
                    </div>     
                       
                    <div className="container_grafico">
                        <div className="header_grafico">
                            {t("dashboard.graficos.titulo_prec")}
                            <img className="img_info ocultar" src="flu/imagens/info32.png"></img>
                        </div>
                        <div className="body_grafico" style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
          
                            <div className={`${style.grafico_pg}`} style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                <Button className={`button_maximize ${style.button_maximize} ${style.float_right}`} onClick={() => setModal2Show(true)}></Button>
                                <Line onClick={() => setModal2Show(true)} options={getOptions_Line(theme, false, t("dashboard.graficos.titulo_prec"))} data={dadosGraficoPrec} />
                            </div>
                         
                            <div className="resumo_grafico" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                <div className={style.titulo_resumo_grafico}>
                                    {t("dashboard.semana_ep")+" "} {semanas[semanas.length - 1]} 
                                </div>
                                <div className="valor_resumo" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                    {ultimoValorPREC !== null ? ultimoValorPREC.toFixed(2) : 0} mm
                                </div>
                                {t("dashboard.graficos.titulo_prec")}
                            </div>
                        </div>
                    </div>    

                    <div className="container_grafico">
                        <div className="header_grafico">
                            {t("dashboard.graficos.titulo_um")}
                            <img className="img_info ocultar" src="flu/imagens/info32.png"></img>
                        </div>
                        <div className="body_grafico" style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
          
                            <div className={`${style.grafico_pg}`} style={{backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                <Button className={`button_maximize ${style.button_maximize} ${style.float_right}`} onClick={() => setModal3Show(true)}></Button>
                                <Line onClick={() => setModal3Show(true)} options={getOptions_Line(theme, true, t("dashboard.graficos.titulo_um"))} data={dadosGraficoUm} />
                            </div>
                         
                            <div className="resumo_grafico" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                <div className={style.titulo_resumo_grafico}>
                                    {t("dashboard.semana_ep")+" "} {semanas[semanas.length - 1]} 
                                </div>
                                <div className="valor_resumo" style={{color:  theme === "dark" ? "white" : "black" ,backgroundColor: theme === "dark" ? "#262626" : "white"}}>
                                    {ultimoValorUM !== null ? ultimoValorUM.toFixed(2) : 0} %
                                </div>
                                {t("dashboard.graficos.titulo_um")} 
                            </div>
                        </div>
                    </div>                                   
                </Row> )}
            </Row> 
            <PopupGrafico
                show={modal1Show}
                onHide={() => setModal1Show(false)}
                options={getOptions_Line(theme, false, t("dashboard.graficos.titulo_temp"))}
                data={dadosGraficoTempFull}
                type="Line"
                titulo={""}
                linguagem={language}
            />
            <PopupGrafico
                show={modal3Show}
                onHide={() => setModal3Show(false)}
                options={getOptions_Line(theme, true, t("dashboard.graficos.titulo_um"))}
                data={dadosGraficoUmFull}
                type="Line"
                titulo={""}
                linguagem={language}
            />

            <PopupGrafico
                show={modal2Show}
                onHide={() => setModal2Show(false)}
                options={getOptions_Line(theme, false, t("dashboard.graficos.titulo_prec"))}
                data={dadosGraficoPrecFull}
                type="Line"
                titulo={""}
                linguagem={language}
                            />
            <Footer date={dataCache}></Footer>
        </Container>
    )
}

export default Clima1